/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as DealRouteImport } from './routes/deal'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthBasicLayoutRouteImport } from './routes/_auth/_basic-layout'
import { Route as AuthSideLayoutRouteImport } from './routes/_auth/_side-layout'
import { Route as AuthAcceptInvitationRouteImport } from './routes/_auth/accept-invitation'
import { Route as AuthClaimRouteImport } from './routes/_auth/claim'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as SharesDashboardIdRouteImport } from './routes/shares.$dashboardId'
import { Route as AuthBasicLayoutAccountRouteImport } from './routes/_auth/_basic-layout/account'
import { Route as AuthBasicLayoutStartTrackingRouteImport } from './routes/_auth/_basic-layout/start-tracking'
import { Route as AuthSideLayoutIndexRouteImport } from './routes/_auth/_side-layout/index'
import { Route as AuthSideLayoutCompaniesRouteImport } from './routes/_auth/_side-layout/companies'
import { Route as AuthSideLayoutDashboardShareRouteImport } from './routes/_auth/_side-layout/dashboard-share'
import { Route as AuthSideLayoutEventsRouteImport } from './routes/_auth/_side-layout/events'
import { Route as AuthSideLayoutFunnelsRouteImport } from './routes/_auth/_side-layout/funnels'
import { Route as AuthSideLayoutGettingStartedRouteImport } from './routes/_auth/_side-layout/getting-started'
import { Route as AuthSideLayoutGroupsRouteImport } from './routes/_auth/_side-layout/groups'
import { Route as AuthSideLayoutHomeRouteImport } from './routes/_auth/_side-layout/home'
import { Route as AuthSideLayoutJourneysRouteImport } from './routes/_auth/_side-layout/journeys'
import { Route as AuthSideLayoutPlaygroundRouteImport } from './routes/_auth/_side-layout/playground'
import { Route as AuthSideLayoutProjectSettingsRouteImport } from './routes/_auth/_side-layout/project-settings'
import { Route as AuthSideLayoutProjectsRouteImport } from './routes/_auth/_side-layout/projects'
import { Route as AuthSideLayoutQueriesRouteImport } from './routes/_auth/_side-layout/queries'
import { Route as AuthSideLayoutReportsRouteImport } from './routes/_auth/_side-layout/reports'
import { Route as AuthSideLayoutRevenueRouteImport } from './routes/_auth/_side-layout/revenue'
import { Route as AuthSideLayoutSearchConsoleRouteImport } from './routes/_auth/_side-layout/search-console'
import { Route as AuthSideLayoutSettingsRouteImport } from './routes/_auth/_side-layout/settings'
import { Route as AuthSideLayoutSuperAdminRouteImport } from './routes/_auth/_side-layout/super-admin'
import { Route as AuthSideLayoutTriggersRouteImport } from './routes/_auth/_side-layout/triggers'
import { Route as AuthSideLayoutUpgradeRouteImport } from './routes/_auth/_side-layout/upgrade'
import { Route as AuthSideLayoutUsersRouteImport } from './routes/_auth/_side-layout/users'
import { Route as AuthSideLayoutActionsIndexRouteImport } from './routes/_auth/_side-layout/actions/index'
import { Route as AuthSideLayoutActionsCatalogRouteImport } from './routes/_auth/_side-layout/actions/catalog'
import { Route as AuthSideLayoutActionsProfilesRouteImport } from './routes/_auth/_side-layout/actions/profiles'
import { Route as AuthSideLayoutActionsSignalsRouteImport } from './routes/_auth/_side-layout/actions/signals'
import { Route as AuthSideLayoutActionsYourActionsRouteImport } from './routes/_auth/_side-layout/actions/your-actions'
import { Route as AuthSideLayoutAutomationsApiKeysRouteImport } from './routes/_auth/_side-layout/automations_.api-keys'
import { Route as AuthSideLayoutAutomationsEnrichmentRouteImport } from './routes/_auth/_side-layout/automations_.enrichment'
import { Route as AuthSideLayoutAutomationsRobotsRouteImport } from './routes/_auth/_side-layout/automations_.robots'
import { Route as AuthSideLayoutCompaniesCompanyIdRouteImport } from './routes/_auth/_side-layout/companies_.$companyId'
import { Route as AuthSideLayoutFunnelsAddFunnelReportRouteImport } from './routes/_auth/_side-layout/funnels_.add-funnel-report'
import { Route as AuthSideLayoutIntegrationsIndexRouteImport } from './routes/_auth/_side-layout/integrations/index'
import { Route as AuthSideLayoutIntegrationsIntegrationIdRouteImport } from './routes/_auth/_side-layout/integrations/$integrationId'
import { Route as AuthSideLayoutIntegrationsAccessRouteImport } from './routes/_auth/_side-layout/integrations/access'
import { Route as AuthSideLayoutIntegrationsConnectedRouteImport } from './routes/_auth/_side-layout/integrations/connected'
import { Route as AuthSideLayoutJourneysAddJourneyReportRouteImport } from './routes/_auth/_side-layout/journeys_.add-journey-report'
import { Route as AuthSideLayoutPaymentsCancelRouteImport } from './routes/_auth/_side-layout/payments.cancel'
import { Route as AuthSideLayoutPaymentsSuccessRouteImport } from './routes/_auth/_side-layout/payments.success'
import { Route as AuthSideLayoutProjectSettingsIndexRouteImport } from './routes/_auth/_side-layout/project-settings/index'
import { Route as AuthSideLayoutProjectSettingsAutocaptureRouteImport } from './routes/_auth/_side-layout/project-settings/autocapture'
import { Route as AuthSideLayoutProjectSettingsConsentRouteImport } from './routes/_auth/_side-layout/project-settings/consent'
import { Route as AuthSideLayoutProjectSettingsDangerZoneRouteImport } from './routes/_auth/_side-layout/project-settings/danger-zone'
import { Route as AuthSideLayoutProjectSettingsDomainsRouteImport } from './routes/_auth/_side-layout/project-settings/domains'
import { Route as AuthSideLayoutProjectSettingsFiltersRouteImport } from './routes/_auth/_side-layout/project-settings/filters'
import { Route as AuthSideLayoutProjectSettingsGeneralRouteImport } from './routes/_auth/_side-layout/project-settings/general'
import { Route as AuthSideLayoutProjectSettingsIdentityRouteImport } from './routes/_auth/_side-layout/project-settings/identity'
import { Route as AuthSideLayoutProjectSettingsIntegrationsRouteImport } from './routes/_auth/_side-layout/project-settings/integrations'
import { Route as AuthSideLayoutProjectSettingsPlaygroundRouteImport } from './routes/_auth/_side-layout/project-settings/playground'
import { Route as AuthSideLayoutProjectSettingsRevenueRouteImport } from './routes/_auth/_side-layout/project-settings/revenue'
import { Route as AuthSideLayoutProjectSettingsSearchConsoleRouteImport } from './routes/_auth/_side-layout/project-settings/search-console'
import { Route as AuthSideLayoutProjectsDetailsRouteImport } from './routes/_auth/_side-layout/projects_.details'
import { Route as AuthSideLayoutReportsAddFunnelReportRouteImport } from './routes/_auth/_side-layout/reports_.add-funnel-report'
import { Route as AuthSideLayoutSettingsAccountRouteImport } from './routes/_auth/_side-layout/settings_.account'
import { Route as AuthSideLayoutSettingsAiRouteImport } from './routes/_auth/_side-layout/settings_.ai'
import { Route as AuthSideLayoutSettingsBillingRouteImport } from './routes/_auth/_side-layout/settings_.billing'
import { Route as AuthSideLayoutSettingsGroupsRouteImport } from './routes/_auth/_side-layout/settings_.groups'
import { Route as AuthSideLayoutSettingsIdentitiesRouteImport } from './routes/_auth/_side-layout/settings_.identities'
import { Route as AuthSideLayoutSettingsIntegrationsRouteImport } from './routes/_auth/_side-layout/settings_.integrations'
import { Route as AuthSideLayoutSettingsMembersRouteImport } from './routes/_auth/_side-layout/settings_.members'
import { Route as AuthSideLayoutSettingsOrganizationRouteImport } from './routes/_auth/_side-layout/settings_.organization'
import { Route as AuthSideLayoutSettingsPrivacyRouteImport } from './routes/_auth/_side-layout/settings_.privacy'
import { Route as AuthSideLayoutSettingsProjectsRouteImport } from './routes/_auth/_side-layout/settings_.projects'
import { Route as AuthSideLayoutSuperAdminIndexRouteImport } from './routes/_auth/_side-layout/super-admin.index'
import { Route as AuthSideLayoutSuperAdminCrmRouteImport } from './routes/_auth/_side-layout/super-admin.crm'
import { Route as AuthSideLayoutSuperAdminEnrichmentRouteImport } from './routes/_auth/_side-layout/super-admin.enrichment'
import { Route as AuthSideLayoutSuperAdminFeaturesRouteImport } from './routes/_auth/_side-layout/super-admin.features'
import { Route as AuthSideLayoutSuperAdminPrivacyRequestsRouteImport } from './routes/_auth/_side-layout/super-admin.privacy-requests'
import { Route as AuthSideLayoutSuperAdminPromosRouteImport } from './routes/_auth/_side-layout/super-admin.promos'
import { Route as AuthSideLayoutSuperAdminSubscriptionsRouteImport } from './routes/_auth/_side-layout/super-admin.subscriptions'
import { Route as AuthSideLayoutSuperAdminUsersRouteImport } from './routes/_auth/_side-layout/super-admin.users'
import { Route as AuthSideLayoutSuperAdminVisitorIdRouteImport } from './routes/_auth/_side-layout/super-admin.visitor-id'
import { Route as AuthSideLayoutSuperAdminWebBrowsingRouteImport } from './routes/_auth/_side-layout/super-admin.web-browsing'
import { Route as AuthSideLayoutUsersUserIdRouteImport } from './routes/_auth/_side-layout/users_.$userId'
import { Route as AuthSideLayoutActionsProfilesIndexRouteImport } from './routes/_auth/_side-layout/actions/profiles/index'
import { Route as AuthSideLayoutActionsProfilesPersonasRouteImport } from './routes/_auth/_side-layout/actions/profiles/personas'
import { Route as AuthSideLayoutActionsProfilesProfilesRouteImport } from './routes/_auth/_side-layout/actions/profiles/profiles'
import { Route as AuthSideLayoutActionsProfilesProfileIdRouteImport } from './routes/_auth/_side-layout/actions/profiles_.$profileId'
import { Route as AuthSideLayoutActionsYourActionsIndexRouteImport } from './routes/_auth/_side-layout/actions/your-actions/index'
import { Route as AuthSideLayoutActionsYourActionsActionsRouteImport } from './routes/_auth/_side-layout/actions/your-actions/actions'
import { Route as AuthSideLayoutActionsYourActionsActivityRouteImport } from './routes/_auth/_side-layout/actions/your-actions/activity'
import { Route as AuthSideLayoutIntegrationsAccessIndexRouteImport } from './routes/_auth/_side-layout/integrations/access/index'
import { Route as AuthSideLayoutIntegrationsAccessApiRouteImport } from './routes/_auth/_side-layout/integrations/access/api'
import { Route as AuthSideLayoutIntegrationsAccessMcpRouteImport } from './routes/_auth/_side-layout/integrations/access/mcp'
import { Route as AuthSideLayoutIntegrationsAttioCallbackRouteImport } from './routes/_auth/_side-layout/integrations/attio.callback'
import { Route as AuthSideLayoutIntegrationsHubspotCallbackRouteImport } from './routes/_auth/_side-layout/integrations/hubspot.callback'
import { Route as AuthSideLayoutIntegrationsSalesforceCallbackRouteImport } from './routes/_auth/_side-layout/integrations/salesforce.callback'
import { Route as AuthSideLayoutIntegrationsSlackCallbackRouteImport } from './routes/_auth/_side-layout/integrations/slack.callback'
import { Route as AuthSideLayoutSettingsIdentitiesIdentityIdRouteImport } from './routes/_auth/_side-layout/settings_.identities_.$identityId'
import { Route as AuthSideLayoutSettingsOrganizationIndexRouteImport } from './routes/_auth/_side-layout/settings_.organization.index'
import { Route as AuthSideLayoutSettingsOrganizationCurrencyRouteImport } from './routes/_auth/_side-layout/settings_.organization.currency'
import { Route as AuthSideLayoutSettingsOrganizationDetailsRouteImport } from './routes/_auth/_side-layout/settings_.organization.details'
import { Route as AuthSideLayoutSettingsPrivacyIndexRouteImport } from './routes/_auth/_side-layout/settings_.privacy.index'
import { Route as AuthSideLayoutSettingsPrivacyConsentSourcesRouteImport } from './routes/_auth/_side-layout/settings_.privacy.consent-sources'
import { Route as AuthSideLayoutSettingsPrivacyRequestsRouteImport } from './routes/_auth/_side-layout/settings_.privacy.requests'
import { Route as AuthSideLayoutSettingsPrivacyServerEventsRouteImport } from './routes/_auth/_side-layout/settings_.privacy.server-events'
import { Route as AuthSideLayoutSettingsPrivacyUserConsentRouteImport } from './routes/_auth/_side-layout/settings_.privacy.user-consent'
import { Route as AuthSideLayoutSuperAdminDataAgentsRouteImport } from './routes/_auth/_side-layout/super-admin.data.agents'
import { Route as AuthSideLayoutSuperAdminDataChangesRouteImport } from './routes/_auth/_side-layout/super-admin.data.changes'
import { Route as AuthSideLayoutSuperAdminDataCompaniesRouteImport } from './routes/_auth/_side-layout/super-admin.data.companies'
import { Route as AuthSideLayoutSuperAdminDataLookupsRouteImport } from './routes/_auth/_side-layout/super-admin.data.lookups'
import { Route as AuthSideLayoutSuperAdminDataPersonasRouteImport } from './routes/_auth/_side-layout/super-admin.data.personas'
import { Route as AuthSideLayoutSuperAdminEnrichmentIndexRouteImport } from './routes/_auth/_side-layout/super-admin.enrichment.index'
import { Route as AuthSideLayoutSuperAdminEnrichmentConfigurationRouteImport } from './routes/_auth/_side-layout/super-admin.enrichment.configuration'
import { Route as AuthSideLayoutSuperAdminEnrichmentProvidersRouteImport } from './routes/_auth/_side-layout/super-admin.enrichment.providers'
import { Route as AuthSideLayoutSuperAdminVisitorIdIndexRouteImport } from './routes/_auth/_side-layout/super-admin.visitor-id.index'
import { Route as AuthSideLayoutSuperAdminVisitorIdConfigurationRouteImport } from './routes/_auth/_side-layout/super-admin.visitor-id.configuration'
import { Route as AuthSideLayoutSuperAdminVisitorIdProvidersRouteImport } from './routes/_auth/_side-layout/super-admin.visitor-id.providers'
import { Route as AuthSideLayoutSuperAdminVisitorIdRegionsRouteImport } from './routes/_auth/_side-layout/super-admin.visitor-id.regions'
import { Route as AuthSideLayoutSuperAdminWebBrowsingIndexRouteImport } from './routes/_auth/_side-layout/super-admin.web-browsing.index'
import { Route as AuthSideLayoutSuperAdminWebBrowsingConfigurationRouteImport } from './routes/_auth/_side-layout/super-admin.web-browsing.configuration'
import { Route as AuthSideLayoutSuperAdminWebBrowsingProvidersRouteImport } from './routes/_auth/_side-layout/super-admin.web-browsing.providers'
import { Route as AuthSideLayoutActionsYourActionsActivityRunIdRouteImport } from './routes/_auth/_side-layout/actions/your-actions_.activity_.$runId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const DealRoute = DealRouteImport.update({
  id: '/deal',
  path: '/deal',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthBasicLayoutRoute = AuthBasicLayoutRouteImport.update({
  id: '/_basic-layout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSideLayoutRoute = AuthSideLayoutRouteImport.update({
  id: '/_side-layout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClaimRoute = AuthClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const SharesDashboardIdRoute = SharesDashboardIdRouteImport.update({
  id: '/shares/$dashboardId',
  path: '/shares/$dashboardId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthBasicLayoutAccountRoute = AuthBasicLayoutAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthBasicLayoutRoute,
} as any)
const AuthBasicLayoutStartTrackingRoute =
  AuthBasicLayoutStartTrackingRouteImport.update({
    id: '/start-tracking',
    path: '/start-tracking',
    getParentRoute: () => AuthBasicLayoutRoute,
  } as any)
const AuthSideLayoutIndexRoute = AuthSideLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutCompaniesRoute = AuthSideLayoutCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutDashboardShareRoute =
  AuthSideLayoutDashboardShareRouteImport.update({
    id: '/dashboard-share',
    path: '/dashboard-share',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutEventsRoute = AuthSideLayoutEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutFunnelsRoute = AuthSideLayoutFunnelsRouteImport.update({
  id: '/funnels',
  path: '/funnels',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutGettingStartedRoute =
  AuthSideLayoutGettingStartedRouteImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutGroupsRoute = AuthSideLayoutGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutHomeRoute = AuthSideLayoutHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutJourneysRoute = AuthSideLayoutJourneysRouteImport.update({
  id: '/journeys',
  path: '/journeys',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutPlaygroundRoute =
  AuthSideLayoutPlaygroundRouteImport.update({
    id: '/playground',
    path: '/playground',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutProjectSettingsRoute =
  AuthSideLayoutProjectSettingsRouteImport.update({
    id: '/project-settings',
    path: '/project-settings',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutProjectsRoute = AuthSideLayoutProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutQueriesRoute = AuthSideLayoutQueriesRouteImport.update({
  id: '/queries',
  path: '/queries',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutReportsRoute = AuthSideLayoutReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutRevenueRoute = AuthSideLayoutRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutSearchConsoleRoute =
  AuthSideLayoutSearchConsoleRouteImport.update({
    id: '/search-console',
    path: '/search-console',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsRoute = AuthSideLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutSuperAdminRoute =
  AuthSideLayoutSuperAdminRouteImport.update({
    id: '/super-admin',
    path: '/super-admin',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutTriggersRoute = AuthSideLayoutTriggersRouteImport.update({
  id: '/triggers',
  path: '/triggers',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutUpgradeRoute = AuthSideLayoutUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutUsersRoute = AuthSideLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthSideLayoutRoute,
} as any)
const AuthSideLayoutActionsIndexRoute =
  AuthSideLayoutActionsIndexRouteImport.update({
    id: '/actions/',
    path: '/actions/',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutActionsCatalogRoute =
  AuthSideLayoutActionsCatalogRouteImport.update({
    id: '/actions/catalog',
    path: '/actions/catalog',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutActionsProfilesRoute =
  AuthSideLayoutActionsProfilesRouteImport.update({
    id: '/actions/profiles',
    path: '/actions/profiles',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutActionsSignalsRoute =
  AuthSideLayoutActionsSignalsRouteImport.update({
    id: '/actions/signals',
    path: '/actions/signals',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutActionsYourActionsRoute =
  AuthSideLayoutActionsYourActionsRouteImport.update({
    id: '/actions/your-actions',
    path: '/actions/your-actions',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutAutomationsApiKeysRoute =
  AuthSideLayoutAutomationsApiKeysRouteImport.update({
    id: '/automations_/api-keys',
    path: '/automations/api-keys',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutAutomationsEnrichmentRoute =
  AuthSideLayoutAutomationsEnrichmentRouteImport.update({
    id: '/automations_/enrichment',
    path: '/automations/enrichment',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutAutomationsRobotsRoute =
  AuthSideLayoutAutomationsRobotsRouteImport.update({
    id: '/automations_/robots',
    path: '/automations/robots',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutCompaniesCompanyIdRoute =
  AuthSideLayoutCompaniesCompanyIdRouteImport.update({
    id: '/companies_/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutFunnelsAddFunnelReportRoute =
  AuthSideLayoutFunnelsAddFunnelReportRouteImport.update({
    id: '/funnels_/add-funnel-report',
    path: '/funnels/add-funnel-report',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsIndexRoute =
  AuthSideLayoutIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsIntegrationIdRoute =
  AuthSideLayoutIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsAccessRoute =
  AuthSideLayoutIntegrationsAccessRouteImport.update({
    id: '/integrations/access',
    path: '/integrations/access',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsConnectedRoute =
  AuthSideLayoutIntegrationsConnectedRouteImport.update({
    id: '/integrations/connected',
    path: '/integrations/connected',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutJourneysAddJourneyReportRoute =
  AuthSideLayoutJourneysAddJourneyReportRouteImport.update({
    id: '/journeys_/add-journey-report',
    path: '/journeys/add-journey-report',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutPaymentsCancelRoute =
  AuthSideLayoutPaymentsCancelRouteImport.update({
    id: '/payments/cancel',
    path: '/payments/cancel',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutPaymentsSuccessRoute =
  AuthSideLayoutPaymentsSuccessRouteImport.update({
    id: '/payments/success',
    path: '/payments/success',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutProjectSettingsIndexRoute =
  AuthSideLayoutProjectSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsAutocaptureRoute =
  AuthSideLayoutProjectSettingsAutocaptureRouteImport.update({
    id: '/autocapture',
    path: '/autocapture',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsConsentRoute =
  AuthSideLayoutProjectSettingsConsentRouteImport.update({
    id: '/consent',
    path: '/consent',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsDangerZoneRoute =
  AuthSideLayoutProjectSettingsDangerZoneRouteImport.update({
    id: '/danger-zone',
    path: '/danger-zone',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsDomainsRoute =
  AuthSideLayoutProjectSettingsDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsFiltersRoute =
  AuthSideLayoutProjectSettingsFiltersRouteImport.update({
    id: '/filters',
    path: '/filters',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsGeneralRoute =
  AuthSideLayoutProjectSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsIdentityRoute =
  AuthSideLayoutProjectSettingsIdentityRouteImport.update({
    id: '/identity',
    path: '/identity',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsIntegrationsRoute =
  AuthSideLayoutProjectSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsPlaygroundRoute =
  AuthSideLayoutProjectSettingsPlaygroundRouteImport.update({
    id: '/playground',
    path: '/playground',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsRevenueRoute =
  AuthSideLayoutProjectSettingsRevenueRouteImport.update({
    id: '/revenue',
    path: '/revenue',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectSettingsSearchConsoleRoute =
  AuthSideLayoutProjectSettingsSearchConsoleRouteImport.update({
    id: '/search-console',
    path: '/search-console',
    getParentRoute: () => AuthSideLayoutProjectSettingsRoute,
  } as any)
const AuthSideLayoutProjectsDetailsRoute =
  AuthSideLayoutProjectsDetailsRouteImport.update({
    id: '/projects_/details',
    path: '/projects/details',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutReportsAddFunnelReportRoute =
  AuthSideLayoutReportsAddFunnelReportRouteImport.update({
    id: '/reports_/add-funnel-report',
    path: '/reports/add-funnel-report',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsAccountRoute =
  AuthSideLayoutSettingsAccountRouteImport.update({
    id: '/settings_/account',
    path: '/settings/account',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsAiRoute =
  AuthSideLayoutSettingsAiRouteImport.update({
    id: '/settings_/ai',
    path: '/settings/ai',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsBillingRoute =
  AuthSideLayoutSettingsBillingRouteImport.update({
    id: '/settings_/billing',
    path: '/settings/billing',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsGroupsRoute =
  AuthSideLayoutSettingsGroupsRouteImport.update({
    id: '/settings_/groups',
    path: '/settings/groups',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsIdentitiesRoute =
  AuthSideLayoutSettingsIdentitiesRouteImport.update({
    id: '/settings_/identities',
    path: '/settings/identities',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsIntegrationsRoute =
  AuthSideLayoutSettingsIntegrationsRouteImport.update({
    id: '/settings_/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsMembersRoute =
  AuthSideLayoutSettingsMembersRouteImport.update({
    id: '/settings_/members',
    path: '/settings/members',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsOrganizationRoute =
  AuthSideLayoutSettingsOrganizationRouteImport.update({
    id: '/settings_/organization',
    path: '/settings/organization',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsPrivacyRoute =
  AuthSideLayoutSettingsPrivacyRouteImport.update({
    id: '/settings_/privacy',
    path: '/settings/privacy',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsProjectsRoute =
  AuthSideLayoutSettingsProjectsRouteImport.update({
    id: '/settings_/projects',
    path: '/settings/projects',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSuperAdminIndexRoute =
  AuthSideLayoutSuperAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminCrmRoute =
  AuthSideLayoutSuperAdminCrmRouteImport.update({
    id: '/crm',
    path: '/crm',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminEnrichmentRoute =
  AuthSideLayoutSuperAdminEnrichmentRouteImport.update({
    id: '/enrichment',
    path: '/enrichment',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminFeaturesRoute =
  AuthSideLayoutSuperAdminFeaturesRouteImport.update({
    id: '/features',
    path: '/features',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminPrivacyRequestsRoute =
  AuthSideLayoutSuperAdminPrivacyRequestsRouteImport.update({
    id: '/privacy-requests',
    path: '/privacy-requests',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminPromosRoute =
  AuthSideLayoutSuperAdminPromosRouteImport.update({
    id: '/promos',
    path: '/promos',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminSubscriptionsRoute =
  AuthSideLayoutSuperAdminSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminUsersRoute =
  AuthSideLayoutSuperAdminUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminVisitorIdRoute =
  AuthSideLayoutSuperAdminVisitorIdRouteImport.update({
    id: '/visitor-id',
    path: '/visitor-id',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminWebBrowsingRoute =
  AuthSideLayoutSuperAdminWebBrowsingRouteImport.update({
    id: '/web-browsing',
    path: '/web-browsing',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutUsersUserIdRoute =
  AuthSideLayoutUsersUserIdRouteImport.update({
    id: '/users_/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutActionsProfilesIndexRoute =
  AuthSideLayoutActionsProfilesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutActionsProfilesRoute,
  } as any)
const AuthSideLayoutActionsProfilesPersonasRoute =
  AuthSideLayoutActionsProfilesPersonasRouteImport.update({
    id: '/personas',
    path: '/personas',
    getParentRoute: () => AuthSideLayoutActionsProfilesRoute,
  } as any)
const AuthSideLayoutActionsProfilesProfilesRoute =
  AuthSideLayoutActionsProfilesProfilesRouteImport.update({
    id: '/profiles',
    path: '/profiles',
    getParentRoute: () => AuthSideLayoutActionsProfilesRoute,
  } as any)
const AuthSideLayoutActionsProfilesProfileIdRoute =
  AuthSideLayoutActionsProfilesProfileIdRouteImport.update({
    id: '/actions/profiles_/$profileId',
    path: '/actions/profiles/$profileId',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutActionsYourActionsIndexRoute =
  AuthSideLayoutActionsYourActionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutActionsYourActionsRoute,
  } as any)
const AuthSideLayoutActionsYourActionsActionsRoute =
  AuthSideLayoutActionsYourActionsActionsRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => AuthSideLayoutActionsYourActionsRoute,
  } as any)
const AuthSideLayoutActionsYourActionsActivityRoute =
  AuthSideLayoutActionsYourActionsActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthSideLayoutActionsYourActionsRoute,
  } as any)
const AuthSideLayoutIntegrationsAccessIndexRoute =
  AuthSideLayoutIntegrationsAccessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutIntegrationsAccessRoute,
  } as any)
const AuthSideLayoutIntegrationsAccessApiRoute =
  AuthSideLayoutIntegrationsAccessApiRouteImport.update({
    id: '/api',
    path: '/api',
    getParentRoute: () => AuthSideLayoutIntegrationsAccessRoute,
  } as any)
const AuthSideLayoutIntegrationsAccessMcpRoute =
  AuthSideLayoutIntegrationsAccessMcpRouteImport.update({
    id: '/mcp',
    path: '/mcp',
    getParentRoute: () => AuthSideLayoutIntegrationsAccessRoute,
  } as any)
const AuthSideLayoutIntegrationsAttioCallbackRoute =
  AuthSideLayoutIntegrationsAttioCallbackRouteImport.update({
    id: '/integrations/attio/callback',
    path: '/integrations/attio/callback',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsHubspotCallbackRoute =
  AuthSideLayoutIntegrationsHubspotCallbackRouteImport.update({
    id: '/integrations/hubspot/callback',
    path: '/integrations/hubspot/callback',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsSalesforceCallbackRoute =
  AuthSideLayoutIntegrationsSalesforceCallbackRouteImport.update({
    id: '/integrations/salesforce/callback',
    path: '/integrations/salesforce/callback',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutIntegrationsSlackCallbackRoute =
  AuthSideLayoutIntegrationsSlackCallbackRouteImport.update({
    id: '/integrations/slack/callback',
    path: '/integrations/slack/callback',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsIdentitiesIdentityIdRoute =
  AuthSideLayoutSettingsIdentitiesIdentityIdRouteImport.update({
    id: '/settings_/identities_/$identityId',
    path: '/settings/identities/$identityId',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)
const AuthSideLayoutSettingsOrganizationIndexRoute =
  AuthSideLayoutSettingsOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutSettingsOrganizationRoute,
  } as any)
const AuthSideLayoutSettingsOrganizationCurrencyRoute =
  AuthSideLayoutSettingsOrganizationCurrencyRouteImport.update({
    id: '/currency',
    path: '/currency',
    getParentRoute: () => AuthSideLayoutSettingsOrganizationRoute,
  } as any)
const AuthSideLayoutSettingsOrganizationDetailsRoute =
  AuthSideLayoutSettingsOrganizationDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthSideLayoutSettingsOrganizationRoute,
  } as any)
const AuthSideLayoutSettingsPrivacyIndexRoute =
  AuthSideLayoutSettingsPrivacyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutSettingsPrivacyRoute,
  } as any)
const AuthSideLayoutSettingsPrivacyConsentSourcesRoute =
  AuthSideLayoutSettingsPrivacyConsentSourcesRouteImport.update({
    id: '/consent-sources',
    path: '/consent-sources',
    getParentRoute: () => AuthSideLayoutSettingsPrivacyRoute,
  } as any)
const AuthSideLayoutSettingsPrivacyRequestsRoute =
  AuthSideLayoutSettingsPrivacyRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AuthSideLayoutSettingsPrivacyRoute,
  } as any)
const AuthSideLayoutSettingsPrivacyServerEventsRoute =
  AuthSideLayoutSettingsPrivacyServerEventsRouteImport.update({
    id: '/server-events',
    path: '/server-events',
    getParentRoute: () => AuthSideLayoutSettingsPrivacyRoute,
  } as any)
const AuthSideLayoutSettingsPrivacyUserConsentRoute =
  AuthSideLayoutSettingsPrivacyUserConsentRouteImport.update({
    id: '/user-consent',
    path: '/user-consent',
    getParentRoute: () => AuthSideLayoutSettingsPrivacyRoute,
  } as any)
const AuthSideLayoutSuperAdminDataAgentsRoute =
  AuthSideLayoutSuperAdminDataAgentsRouteImport.update({
    id: '/data/agents',
    path: '/data/agents',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminDataChangesRoute =
  AuthSideLayoutSuperAdminDataChangesRouteImport.update({
    id: '/data/changes',
    path: '/data/changes',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminDataCompaniesRoute =
  AuthSideLayoutSuperAdminDataCompaniesRouteImport.update({
    id: '/data/companies',
    path: '/data/companies',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminDataLookupsRoute =
  AuthSideLayoutSuperAdminDataLookupsRouteImport.update({
    id: '/data/lookups',
    path: '/data/lookups',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminDataPersonasRoute =
  AuthSideLayoutSuperAdminDataPersonasRouteImport.update({
    id: '/data/personas',
    path: '/data/personas',
    getParentRoute: () => AuthSideLayoutSuperAdminRoute,
  } as any)
const AuthSideLayoutSuperAdminEnrichmentIndexRoute =
  AuthSideLayoutSuperAdminEnrichmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutSuperAdminEnrichmentRoute,
  } as any)
const AuthSideLayoutSuperAdminEnrichmentConfigurationRoute =
  AuthSideLayoutSuperAdminEnrichmentConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AuthSideLayoutSuperAdminEnrichmentRoute,
  } as any)
const AuthSideLayoutSuperAdminEnrichmentProvidersRoute =
  AuthSideLayoutSuperAdminEnrichmentProvidersRouteImport.update({
    id: '/providers',
    path: '/providers',
    getParentRoute: () => AuthSideLayoutSuperAdminEnrichmentRoute,
  } as any)
const AuthSideLayoutSuperAdminVisitorIdIndexRoute =
  AuthSideLayoutSuperAdminVisitorIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutSuperAdminVisitorIdRoute,
  } as any)
const AuthSideLayoutSuperAdminVisitorIdConfigurationRoute =
  AuthSideLayoutSuperAdminVisitorIdConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AuthSideLayoutSuperAdminVisitorIdRoute,
  } as any)
const AuthSideLayoutSuperAdminVisitorIdProvidersRoute =
  AuthSideLayoutSuperAdminVisitorIdProvidersRouteImport.update({
    id: '/providers',
    path: '/providers',
    getParentRoute: () => AuthSideLayoutSuperAdminVisitorIdRoute,
  } as any)
const AuthSideLayoutSuperAdminVisitorIdRegionsRoute =
  AuthSideLayoutSuperAdminVisitorIdRegionsRouteImport.update({
    id: '/regions',
    path: '/regions',
    getParentRoute: () => AuthSideLayoutSuperAdminVisitorIdRoute,
  } as any)
const AuthSideLayoutSuperAdminWebBrowsingIndexRoute =
  AuthSideLayoutSuperAdminWebBrowsingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSideLayoutSuperAdminWebBrowsingRoute,
  } as any)
const AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute =
  AuthSideLayoutSuperAdminWebBrowsingConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AuthSideLayoutSuperAdminWebBrowsingRoute,
  } as any)
const AuthSideLayoutSuperAdminWebBrowsingProvidersRoute =
  AuthSideLayoutSuperAdminWebBrowsingProvidersRouteImport.update({
    id: '/providers',
    path: '/providers',
    getParentRoute: () => AuthSideLayoutSuperAdminWebBrowsingRoute,
  } as any)
const AuthSideLayoutActionsYourActionsActivityRunIdRoute =
  AuthSideLayoutActionsYourActionsActivityRunIdRouteImport.update({
    id: '/actions/your-actions_/activity_/$runId',
    path: '/actions/your-actions/activity/$runId',
    getParentRoute: () => AuthSideLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthSideLayoutIndexRoute
  '/consent': typeof ConsentRoute
  '/deal': typeof DealRoute
  '/demo': typeof DemoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/claim': typeof AuthClaimRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/shares/$dashboardId': typeof SharesDashboardIdRoute
  '/account': typeof AuthBasicLayoutAccountRoute
  '/start-tracking': typeof AuthBasicLayoutStartTrackingRoute
  '/companies': typeof AuthSideLayoutCompaniesRoute
  '/dashboard-share': typeof AuthSideLayoutDashboardShareRoute
  '/events': typeof AuthSideLayoutEventsRoute
  '/funnels': typeof AuthSideLayoutFunnelsRoute
  '/getting-started': typeof AuthSideLayoutGettingStartedRoute
  '/groups': typeof AuthSideLayoutGroupsRoute
  '/home': typeof AuthSideLayoutHomeRoute
  '/journeys': typeof AuthSideLayoutJourneysRoute
  '/playground': typeof AuthSideLayoutPlaygroundRoute
  '/project-settings': typeof AuthSideLayoutProjectSettingsRouteWithChildren
  '/projects': typeof AuthSideLayoutProjectsRoute
  '/queries': typeof AuthSideLayoutQueriesRoute
  '/reports': typeof AuthSideLayoutReportsRoute
  '/revenue': typeof AuthSideLayoutRevenueRoute
  '/search-console': typeof AuthSideLayoutSearchConsoleRoute
  '/settings': typeof AuthSideLayoutSettingsRoute
  '/super-admin': typeof AuthSideLayoutSuperAdminRouteWithChildren
  '/triggers': typeof AuthSideLayoutTriggersRoute
  '/upgrade': typeof AuthSideLayoutUpgradeRoute
  '/users': typeof AuthSideLayoutUsersRoute
  '/actions/catalog': typeof AuthSideLayoutActionsCatalogRoute
  '/actions/profiles': typeof AuthSideLayoutActionsProfilesRouteWithChildren
  '/actions/signals': typeof AuthSideLayoutActionsSignalsRoute
  '/actions/your-actions': typeof AuthSideLayoutActionsYourActionsRouteWithChildren
  '/automations/api-keys': typeof AuthSideLayoutAutomationsApiKeysRoute
  '/automations/enrichment': typeof AuthSideLayoutAutomationsEnrichmentRoute
  '/automations/robots': typeof AuthSideLayoutAutomationsRobotsRoute
  '/companies/$companyId': typeof AuthSideLayoutCompaniesCompanyIdRoute
  '/funnels/add-funnel-report': typeof AuthSideLayoutFunnelsAddFunnelReportRoute
  '/integrations/$integrationId': typeof AuthSideLayoutIntegrationsIntegrationIdRoute
  '/integrations/access': typeof AuthSideLayoutIntegrationsAccessRouteWithChildren
  '/integrations/connected': typeof AuthSideLayoutIntegrationsConnectedRoute
  '/journeys/add-journey-report': typeof AuthSideLayoutJourneysAddJourneyReportRoute
  '/payments/cancel': typeof AuthSideLayoutPaymentsCancelRoute
  '/payments/success': typeof AuthSideLayoutPaymentsSuccessRoute
  '/project-settings/autocapture': typeof AuthSideLayoutProjectSettingsAutocaptureRoute
  '/project-settings/consent': typeof AuthSideLayoutProjectSettingsConsentRoute
  '/project-settings/danger-zone': typeof AuthSideLayoutProjectSettingsDangerZoneRoute
  '/project-settings/domains': typeof AuthSideLayoutProjectSettingsDomainsRoute
  '/project-settings/filters': typeof AuthSideLayoutProjectSettingsFiltersRoute
  '/project-settings/general': typeof AuthSideLayoutProjectSettingsGeneralRoute
  '/project-settings/identity': typeof AuthSideLayoutProjectSettingsIdentityRoute
  '/project-settings/integrations': typeof AuthSideLayoutProjectSettingsIntegrationsRoute
  '/project-settings/playground': typeof AuthSideLayoutProjectSettingsPlaygroundRoute
  '/project-settings/revenue': typeof AuthSideLayoutProjectSettingsRevenueRoute
  '/project-settings/search-console': typeof AuthSideLayoutProjectSettingsSearchConsoleRoute
  '/projects/details': typeof AuthSideLayoutProjectsDetailsRoute
  '/reports/add-funnel-report': typeof AuthSideLayoutReportsAddFunnelReportRoute
  '/settings/account': typeof AuthSideLayoutSettingsAccountRoute
  '/settings/ai': typeof AuthSideLayoutSettingsAiRoute
  '/settings/billing': typeof AuthSideLayoutSettingsBillingRoute
  '/settings/groups': typeof AuthSideLayoutSettingsGroupsRoute
  '/settings/identities': typeof AuthSideLayoutSettingsIdentitiesRoute
  '/settings/integrations': typeof AuthSideLayoutSettingsIntegrationsRoute
  '/settings/members': typeof AuthSideLayoutSettingsMembersRoute
  '/settings/organization': typeof AuthSideLayoutSettingsOrganizationRouteWithChildren
  '/settings/privacy': typeof AuthSideLayoutSettingsPrivacyRouteWithChildren
  '/settings/projects': typeof AuthSideLayoutSettingsProjectsRoute
  '/super-admin/crm': typeof AuthSideLayoutSuperAdminCrmRoute
  '/super-admin/enrichment': typeof AuthSideLayoutSuperAdminEnrichmentRouteWithChildren
  '/super-admin/features': typeof AuthSideLayoutSuperAdminFeaturesRoute
  '/super-admin/privacy-requests': typeof AuthSideLayoutSuperAdminPrivacyRequestsRoute
  '/super-admin/promos': typeof AuthSideLayoutSuperAdminPromosRoute
  '/super-admin/subscriptions': typeof AuthSideLayoutSuperAdminSubscriptionsRoute
  '/super-admin/users': typeof AuthSideLayoutSuperAdminUsersRoute
  '/super-admin/visitor-id': typeof AuthSideLayoutSuperAdminVisitorIdRouteWithChildren
  '/super-admin/web-browsing': typeof AuthSideLayoutSuperAdminWebBrowsingRouteWithChildren
  '/users/$userId': typeof AuthSideLayoutUsersUserIdRoute
  '/actions/': typeof AuthSideLayoutActionsIndexRoute
  '/integrations/': typeof AuthSideLayoutIntegrationsIndexRoute
  '/project-settings/': typeof AuthSideLayoutProjectSettingsIndexRoute
  '/super-admin/': typeof AuthSideLayoutSuperAdminIndexRoute
  '/actions/profiles/personas': typeof AuthSideLayoutActionsProfilesPersonasRoute
  '/actions/profiles/profiles': typeof AuthSideLayoutActionsProfilesProfilesRoute
  '/actions/profiles/$profileId': typeof AuthSideLayoutActionsProfilesProfileIdRoute
  '/actions/your-actions/actions': typeof AuthSideLayoutActionsYourActionsActionsRoute
  '/actions/your-actions/activity': typeof AuthSideLayoutActionsYourActionsActivityRoute
  '/integrations/access/api': typeof AuthSideLayoutIntegrationsAccessApiRoute
  '/integrations/access/mcp': typeof AuthSideLayoutIntegrationsAccessMcpRoute
  '/integrations/attio/callback': typeof AuthSideLayoutIntegrationsAttioCallbackRoute
  '/integrations/hubspot/callback': typeof AuthSideLayoutIntegrationsHubspotCallbackRoute
  '/integrations/salesforce/callback': typeof AuthSideLayoutIntegrationsSalesforceCallbackRoute
  '/integrations/slack/callback': typeof AuthSideLayoutIntegrationsSlackCallbackRoute
  '/settings/identities/$identityId': typeof AuthSideLayoutSettingsIdentitiesIdentityIdRoute
  '/settings/organization/currency': typeof AuthSideLayoutSettingsOrganizationCurrencyRoute
  '/settings/organization/details': typeof AuthSideLayoutSettingsOrganizationDetailsRoute
  '/settings/privacy/consent-sources': typeof AuthSideLayoutSettingsPrivacyConsentSourcesRoute
  '/settings/privacy/requests': typeof AuthSideLayoutSettingsPrivacyRequestsRoute
  '/settings/privacy/server-events': typeof AuthSideLayoutSettingsPrivacyServerEventsRoute
  '/settings/privacy/user-consent': typeof AuthSideLayoutSettingsPrivacyUserConsentRoute
  '/super-admin/data/agents': typeof AuthSideLayoutSuperAdminDataAgentsRoute
  '/super-admin/data/changes': typeof AuthSideLayoutSuperAdminDataChangesRoute
  '/super-admin/data/companies': typeof AuthSideLayoutSuperAdminDataCompaniesRoute
  '/super-admin/data/lookups': typeof AuthSideLayoutSuperAdminDataLookupsRoute
  '/super-admin/data/personas': typeof AuthSideLayoutSuperAdminDataPersonasRoute
  '/super-admin/enrichment/configuration': typeof AuthSideLayoutSuperAdminEnrichmentConfigurationRoute
  '/super-admin/enrichment/providers': typeof AuthSideLayoutSuperAdminEnrichmentProvidersRoute
  '/super-admin/visitor-id/configuration': typeof AuthSideLayoutSuperAdminVisitorIdConfigurationRoute
  '/super-admin/visitor-id/providers': typeof AuthSideLayoutSuperAdminVisitorIdProvidersRoute
  '/super-admin/visitor-id/regions': typeof AuthSideLayoutSuperAdminVisitorIdRegionsRoute
  '/super-admin/web-browsing/configuration': typeof AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute
  '/super-admin/web-browsing/providers': typeof AuthSideLayoutSuperAdminWebBrowsingProvidersRoute
  '/actions/profiles/': typeof AuthSideLayoutActionsProfilesIndexRoute
  '/actions/your-actions/': typeof AuthSideLayoutActionsYourActionsIndexRoute
  '/integrations/access/': typeof AuthSideLayoutIntegrationsAccessIndexRoute
  '/settings/organization/': typeof AuthSideLayoutSettingsOrganizationIndexRoute
  '/settings/privacy/': typeof AuthSideLayoutSettingsPrivacyIndexRoute
  '/super-admin/enrichment/': typeof AuthSideLayoutSuperAdminEnrichmentIndexRoute
  '/super-admin/visitor-id/': typeof AuthSideLayoutSuperAdminVisitorIdIndexRoute
  '/super-admin/web-browsing/': typeof AuthSideLayoutSuperAdminWebBrowsingIndexRoute
  '/actions/your-actions/activity/$runId': typeof AuthSideLayoutActionsYourActionsActivityRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthSideLayoutIndexRoute
  '/consent': typeof ConsentRoute
  '/deal': typeof DealRoute
  '/demo': typeof DemoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/claim': typeof AuthClaimRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/shares/$dashboardId': typeof SharesDashboardIdRoute
  '/account': typeof AuthBasicLayoutAccountRoute
  '/start-tracking': typeof AuthBasicLayoutStartTrackingRoute
  '/companies': typeof AuthSideLayoutCompaniesRoute
  '/dashboard-share': typeof AuthSideLayoutDashboardShareRoute
  '/events': typeof AuthSideLayoutEventsRoute
  '/funnels': typeof AuthSideLayoutFunnelsRoute
  '/getting-started': typeof AuthSideLayoutGettingStartedRoute
  '/groups': typeof AuthSideLayoutGroupsRoute
  '/home': typeof AuthSideLayoutHomeRoute
  '/journeys': typeof AuthSideLayoutJourneysRoute
  '/playground': typeof AuthSideLayoutPlaygroundRoute
  '/projects': typeof AuthSideLayoutProjectsRoute
  '/queries': typeof AuthSideLayoutQueriesRoute
  '/reports': typeof AuthSideLayoutReportsRoute
  '/revenue': typeof AuthSideLayoutRevenueRoute
  '/search-console': typeof AuthSideLayoutSearchConsoleRoute
  '/settings': typeof AuthSideLayoutSettingsRoute
  '/triggers': typeof AuthSideLayoutTriggersRoute
  '/upgrade': typeof AuthSideLayoutUpgradeRoute
  '/users': typeof AuthSideLayoutUsersRoute
  '/actions/catalog': typeof AuthSideLayoutActionsCatalogRoute
  '/actions/signals': typeof AuthSideLayoutActionsSignalsRoute
  '/automations/api-keys': typeof AuthSideLayoutAutomationsApiKeysRoute
  '/automations/enrichment': typeof AuthSideLayoutAutomationsEnrichmentRoute
  '/automations/robots': typeof AuthSideLayoutAutomationsRobotsRoute
  '/companies/$companyId': typeof AuthSideLayoutCompaniesCompanyIdRoute
  '/funnels/add-funnel-report': typeof AuthSideLayoutFunnelsAddFunnelReportRoute
  '/integrations/$integrationId': typeof AuthSideLayoutIntegrationsIntegrationIdRoute
  '/integrations/connected': typeof AuthSideLayoutIntegrationsConnectedRoute
  '/journeys/add-journey-report': typeof AuthSideLayoutJourneysAddJourneyReportRoute
  '/payments/cancel': typeof AuthSideLayoutPaymentsCancelRoute
  '/payments/success': typeof AuthSideLayoutPaymentsSuccessRoute
  '/project-settings/autocapture': typeof AuthSideLayoutProjectSettingsAutocaptureRoute
  '/project-settings/consent': typeof AuthSideLayoutProjectSettingsConsentRoute
  '/project-settings/danger-zone': typeof AuthSideLayoutProjectSettingsDangerZoneRoute
  '/project-settings/domains': typeof AuthSideLayoutProjectSettingsDomainsRoute
  '/project-settings/filters': typeof AuthSideLayoutProjectSettingsFiltersRoute
  '/project-settings/general': typeof AuthSideLayoutProjectSettingsGeneralRoute
  '/project-settings/identity': typeof AuthSideLayoutProjectSettingsIdentityRoute
  '/project-settings/integrations': typeof AuthSideLayoutProjectSettingsIntegrationsRoute
  '/project-settings/playground': typeof AuthSideLayoutProjectSettingsPlaygroundRoute
  '/project-settings/revenue': typeof AuthSideLayoutProjectSettingsRevenueRoute
  '/project-settings/search-console': typeof AuthSideLayoutProjectSettingsSearchConsoleRoute
  '/projects/details': typeof AuthSideLayoutProjectsDetailsRoute
  '/reports/add-funnel-report': typeof AuthSideLayoutReportsAddFunnelReportRoute
  '/settings/account': typeof AuthSideLayoutSettingsAccountRoute
  '/settings/ai': typeof AuthSideLayoutSettingsAiRoute
  '/settings/billing': typeof AuthSideLayoutSettingsBillingRoute
  '/settings/groups': typeof AuthSideLayoutSettingsGroupsRoute
  '/settings/identities': typeof AuthSideLayoutSettingsIdentitiesRoute
  '/settings/integrations': typeof AuthSideLayoutSettingsIntegrationsRoute
  '/settings/members': typeof AuthSideLayoutSettingsMembersRoute
  '/settings/projects': typeof AuthSideLayoutSettingsProjectsRoute
  '/super-admin/crm': typeof AuthSideLayoutSuperAdminCrmRoute
  '/super-admin/features': typeof AuthSideLayoutSuperAdminFeaturesRoute
  '/super-admin/privacy-requests': typeof AuthSideLayoutSuperAdminPrivacyRequestsRoute
  '/super-admin/promos': typeof AuthSideLayoutSuperAdminPromosRoute
  '/super-admin/subscriptions': typeof AuthSideLayoutSuperAdminSubscriptionsRoute
  '/super-admin/users': typeof AuthSideLayoutSuperAdminUsersRoute
  '/users/$userId': typeof AuthSideLayoutUsersUserIdRoute
  '/actions': typeof AuthSideLayoutActionsIndexRoute
  '/integrations': typeof AuthSideLayoutIntegrationsIndexRoute
  '/project-settings': typeof AuthSideLayoutProjectSettingsIndexRoute
  '/super-admin': typeof AuthSideLayoutSuperAdminIndexRoute
  '/actions/profiles/personas': typeof AuthSideLayoutActionsProfilesPersonasRoute
  '/actions/profiles/profiles': typeof AuthSideLayoutActionsProfilesProfilesRoute
  '/actions/profiles/$profileId': typeof AuthSideLayoutActionsProfilesProfileIdRoute
  '/actions/your-actions/actions': typeof AuthSideLayoutActionsYourActionsActionsRoute
  '/actions/your-actions/activity': typeof AuthSideLayoutActionsYourActionsActivityRoute
  '/integrations/access/api': typeof AuthSideLayoutIntegrationsAccessApiRoute
  '/integrations/access/mcp': typeof AuthSideLayoutIntegrationsAccessMcpRoute
  '/integrations/attio/callback': typeof AuthSideLayoutIntegrationsAttioCallbackRoute
  '/integrations/hubspot/callback': typeof AuthSideLayoutIntegrationsHubspotCallbackRoute
  '/integrations/salesforce/callback': typeof AuthSideLayoutIntegrationsSalesforceCallbackRoute
  '/integrations/slack/callback': typeof AuthSideLayoutIntegrationsSlackCallbackRoute
  '/settings/identities/$identityId': typeof AuthSideLayoutSettingsIdentitiesIdentityIdRoute
  '/settings/organization/currency': typeof AuthSideLayoutSettingsOrganizationCurrencyRoute
  '/settings/organization/details': typeof AuthSideLayoutSettingsOrganizationDetailsRoute
  '/settings/privacy/consent-sources': typeof AuthSideLayoutSettingsPrivacyConsentSourcesRoute
  '/settings/privacy/requests': typeof AuthSideLayoutSettingsPrivacyRequestsRoute
  '/settings/privacy/server-events': typeof AuthSideLayoutSettingsPrivacyServerEventsRoute
  '/settings/privacy/user-consent': typeof AuthSideLayoutSettingsPrivacyUserConsentRoute
  '/super-admin/data/agents': typeof AuthSideLayoutSuperAdminDataAgentsRoute
  '/super-admin/data/changes': typeof AuthSideLayoutSuperAdminDataChangesRoute
  '/super-admin/data/companies': typeof AuthSideLayoutSuperAdminDataCompaniesRoute
  '/super-admin/data/lookups': typeof AuthSideLayoutSuperAdminDataLookupsRoute
  '/super-admin/data/personas': typeof AuthSideLayoutSuperAdminDataPersonasRoute
  '/super-admin/enrichment/configuration': typeof AuthSideLayoutSuperAdminEnrichmentConfigurationRoute
  '/super-admin/enrichment/providers': typeof AuthSideLayoutSuperAdminEnrichmentProvidersRoute
  '/super-admin/visitor-id/configuration': typeof AuthSideLayoutSuperAdminVisitorIdConfigurationRoute
  '/super-admin/visitor-id/providers': typeof AuthSideLayoutSuperAdminVisitorIdProvidersRoute
  '/super-admin/visitor-id/regions': typeof AuthSideLayoutSuperAdminVisitorIdRegionsRoute
  '/super-admin/web-browsing/configuration': typeof AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute
  '/super-admin/web-browsing/providers': typeof AuthSideLayoutSuperAdminWebBrowsingProvidersRoute
  '/actions/profiles': typeof AuthSideLayoutActionsProfilesIndexRoute
  '/actions/your-actions': typeof AuthSideLayoutActionsYourActionsIndexRoute
  '/integrations/access': typeof AuthSideLayoutIntegrationsAccessIndexRoute
  '/settings/organization': typeof AuthSideLayoutSettingsOrganizationIndexRoute
  '/settings/privacy': typeof AuthSideLayoutSettingsPrivacyIndexRoute
  '/super-admin/enrichment': typeof AuthSideLayoutSuperAdminEnrichmentIndexRoute
  '/super-admin/visitor-id': typeof AuthSideLayoutSuperAdminVisitorIdIndexRoute
  '/super-admin/web-browsing': typeof AuthSideLayoutSuperAdminWebBrowsingIndexRoute
  '/actions/your-actions/activity/$runId': typeof AuthSideLayoutActionsYourActionsActivityRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/consent': typeof ConsentRoute
  '/deal': typeof DealRoute
  '/demo': typeof DemoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_auth/_basic-layout': typeof AuthBasicLayoutRouteWithChildren
  '/_auth/_side-layout': typeof AuthSideLayoutRouteWithChildren
  '/_auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/_auth/claim': typeof AuthClaimRoute
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/shares/$dashboardId': typeof SharesDashboardIdRoute
  '/_auth/_basic-layout/account': typeof AuthBasicLayoutAccountRoute
  '/_auth/_basic-layout/start-tracking': typeof AuthBasicLayoutStartTrackingRoute
  '/_auth/_side-layout/companies': typeof AuthSideLayoutCompaniesRoute
  '/_auth/_side-layout/dashboard-share': typeof AuthSideLayoutDashboardShareRoute
  '/_auth/_side-layout/events': typeof AuthSideLayoutEventsRoute
  '/_auth/_side-layout/funnels': typeof AuthSideLayoutFunnelsRoute
  '/_auth/_side-layout/getting-started': typeof AuthSideLayoutGettingStartedRoute
  '/_auth/_side-layout/groups': typeof AuthSideLayoutGroupsRoute
  '/_auth/_side-layout/home': typeof AuthSideLayoutHomeRoute
  '/_auth/_side-layout/journeys': typeof AuthSideLayoutJourneysRoute
  '/_auth/_side-layout/playground': typeof AuthSideLayoutPlaygroundRoute
  '/_auth/_side-layout/project-settings': typeof AuthSideLayoutProjectSettingsRouteWithChildren
  '/_auth/_side-layout/projects': typeof AuthSideLayoutProjectsRoute
  '/_auth/_side-layout/queries': typeof AuthSideLayoutQueriesRoute
  '/_auth/_side-layout/reports': typeof AuthSideLayoutReportsRoute
  '/_auth/_side-layout/revenue': typeof AuthSideLayoutRevenueRoute
  '/_auth/_side-layout/search-console': typeof AuthSideLayoutSearchConsoleRoute
  '/_auth/_side-layout/settings': typeof AuthSideLayoutSettingsRoute
  '/_auth/_side-layout/super-admin': typeof AuthSideLayoutSuperAdminRouteWithChildren
  '/_auth/_side-layout/triggers': typeof AuthSideLayoutTriggersRoute
  '/_auth/_side-layout/upgrade': typeof AuthSideLayoutUpgradeRoute
  '/_auth/_side-layout/users': typeof AuthSideLayoutUsersRoute
  '/_auth/_side-layout/': typeof AuthSideLayoutIndexRoute
  '/_auth/_side-layout/actions/catalog': typeof AuthSideLayoutActionsCatalogRoute
  '/_auth/_side-layout/actions/profiles': typeof AuthSideLayoutActionsProfilesRouteWithChildren
  '/_auth/_side-layout/actions/signals': typeof AuthSideLayoutActionsSignalsRoute
  '/_auth/_side-layout/actions/your-actions': typeof AuthSideLayoutActionsYourActionsRouteWithChildren
  '/_auth/_side-layout/automations_/api-keys': typeof AuthSideLayoutAutomationsApiKeysRoute
  '/_auth/_side-layout/automations_/enrichment': typeof AuthSideLayoutAutomationsEnrichmentRoute
  '/_auth/_side-layout/automations_/robots': typeof AuthSideLayoutAutomationsRobotsRoute
  '/_auth/_side-layout/companies_/$companyId': typeof AuthSideLayoutCompaniesCompanyIdRoute
  '/_auth/_side-layout/funnels_/add-funnel-report': typeof AuthSideLayoutFunnelsAddFunnelReportRoute
  '/_auth/_side-layout/integrations/$integrationId': typeof AuthSideLayoutIntegrationsIntegrationIdRoute
  '/_auth/_side-layout/integrations/access': typeof AuthSideLayoutIntegrationsAccessRouteWithChildren
  '/_auth/_side-layout/integrations/connected': typeof AuthSideLayoutIntegrationsConnectedRoute
  '/_auth/_side-layout/journeys_/add-journey-report': typeof AuthSideLayoutJourneysAddJourneyReportRoute
  '/_auth/_side-layout/payments/cancel': typeof AuthSideLayoutPaymentsCancelRoute
  '/_auth/_side-layout/payments/success': typeof AuthSideLayoutPaymentsSuccessRoute
  '/_auth/_side-layout/project-settings/autocapture': typeof AuthSideLayoutProjectSettingsAutocaptureRoute
  '/_auth/_side-layout/project-settings/consent': typeof AuthSideLayoutProjectSettingsConsentRoute
  '/_auth/_side-layout/project-settings/danger-zone': typeof AuthSideLayoutProjectSettingsDangerZoneRoute
  '/_auth/_side-layout/project-settings/domains': typeof AuthSideLayoutProjectSettingsDomainsRoute
  '/_auth/_side-layout/project-settings/filters': typeof AuthSideLayoutProjectSettingsFiltersRoute
  '/_auth/_side-layout/project-settings/general': typeof AuthSideLayoutProjectSettingsGeneralRoute
  '/_auth/_side-layout/project-settings/identity': typeof AuthSideLayoutProjectSettingsIdentityRoute
  '/_auth/_side-layout/project-settings/integrations': typeof AuthSideLayoutProjectSettingsIntegrationsRoute
  '/_auth/_side-layout/project-settings/playground': typeof AuthSideLayoutProjectSettingsPlaygroundRoute
  '/_auth/_side-layout/project-settings/revenue': typeof AuthSideLayoutProjectSettingsRevenueRoute
  '/_auth/_side-layout/project-settings/search-console': typeof AuthSideLayoutProjectSettingsSearchConsoleRoute
  '/_auth/_side-layout/projects_/details': typeof AuthSideLayoutProjectsDetailsRoute
  '/_auth/_side-layout/reports_/add-funnel-report': typeof AuthSideLayoutReportsAddFunnelReportRoute
  '/_auth/_side-layout/settings_/account': typeof AuthSideLayoutSettingsAccountRoute
  '/_auth/_side-layout/settings_/ai': typeof AuthSideLayoutSettingsAiRoute
  '/_auth/_side-layout/settings_/billing': typeof AuthSideLayoutSettingsBillingRoute
  '/_auth/_side-layout/settings_/groups': typeof AuthSideLayoutSettingsGroupsRoute
  '/_auth/_side-layout/settings_/identities': typeof AuthSideLayoutSettingsIdentitiesRoute
  '/_auth/_side-layout/settings_/integrations': typeof AuthSideLayoutSettingsIntegrationsRoute
  '/_auth/_side-layout/settings_/members': typeof AuthSideLayoutSettingsMembersRoute
  '/_auth/_side-layout/settings_/organization': typeof AuthSideLayoutSettingsOrganizationRouteWithChildren
  '/_auth/_side-layout/settings_/privacy': typeof AuthSideLayoutSettingsPrivacyRouteWithChildren
  '/_auth/_side-layout/settings_/projects': typeof AuthSideLayoutSettingsProjectsRoute
  '/_auth/_side-layout/super-admin/crm': typeof AuthSideLayoutSuperAdminCrmRoute
  '/_auth/_side-layout/super-admin/enrichment': typeof AuthSideLayoutSuperAdminEnrichmentRouteWithChildren
  '/_auth/_side-layout/super-admin/features': typeof AuthSideLayoutSuperAdminFeaturesRoute
  '/_auth/_side-layout/super-admin/privacy-requests': typeof AuthSideLayoutSuperAdminPrivacyRequestsRoute
  '/_auth/_side-layout/super-admin/promos': typeof AuthSideLayoutSuperAdminPromosRoute
  '/_auth/_side-layout/super-admin/subscriptions': typeof AuthSideLayoutSuperAdminSubscriptionsRoute
  '/_auth/_side-layout/super-admin/users': typeof AuthSideLayoutSuperAdminUsersRoute
  '/_auth/_side-layout/super-admin/visitor-id': typeof AuthSideLayoutSuperAdminVisitorIdRouteWithChildren
  '/_auth/_side-layout/super-admin/web-browsing': typeof AuthSideLayoutSuperAdminWebBrowsingRouteWithChildren
  '/_auth/_side-layout/users_/$userId': typeof AuthSideLayoutUsersUserIdRoute
  '/_auth/_side-layout/actions/': typeof AuthSideLayoutActionsIndexRoute
  '/_auth/_side-layout/integrations/': typeof AuthSideLayoutIntegrationsIndexRoute
  '/_auth/_side-layout/project-settings/': typeof AuthSideLayoutProjectSettingsIndexRoute
  '/_auth/_side-layout/super-admin/': typeof AuthSideLayoutSuperAdminIndexRoute
  '/_auth/_side-layout/actions/profiles/personas': typeof AuthSideLayoutActionsProfilesPersonasRoute
  '/_auth/_side-layout/actions/profiles/profiles': typeof AuthSideLayoutActionsProfilesProfilesRoute
  '/_auth/_side-layout/actions/profiles_/$profileId': typeof AuthSideLayoutActionsProfilesProfileIdRoute
  '/_auth/_side-layout/actions/your-actions/actions': typeof AuthSideLayoutActionsYourActionsActionsRoute
  '/_auth/_side-layout/actions/your-actions/activity': typeof AuthSideLayoutActionsYourActionsActivityRoute
  '/_auth/_side-layout/integrations/access/api': typeof AuthSideLayoutIntegrationsAccessApiRoute
  '/_auth/_side-layout/integrations/access/mcp': typeof AuthSideLayoutIntegrationsAccessMcpRoute
  '/_auth/_side-layout/integrations/attio/callback': typeof AuthSideLayoutIntegrationsAttioCallbackRoute
  '/_auth/_side-layout/integrations/hubspot/callback': typeof AuthSideLayoutIntegrationsHubspotCallbackRoute
  '/_auth/_side-layout/integrations/salesforce/callback': typeof AuthSideLayoutIntegrationsSalesforceCallbackRoute
  '/_auth/_side-layout/integrations/slack/callback': typeof AuthSideLayoutIntegrationsSlackCallbackRoute
  '/_auth/_side-layout/settings_/identities_/$identityId': typeof AuthSideLayoutSettingsIdentitiesIdentityIdRoute
  '/_auth/_side-layout/settings_/organization/currency': typeof AuthSideLayoutSettingsOrganizationCurrencyRoute
  '/_auth/_side-layout/settings_/organization/details': typeof AuthSideLayoutSettingsOrganizationDetailsRoute
  '/_auth/_side-layout/settings_/privacy/consent-sources': typeof AuthSideLayoutSettingsPrivacyConsentSourcesRoute
  '/_auth/_side-layout/settings_/privacy/requests': typeof AuthSideLayoutSettingsPrivacyRequestsRoute
  '/_auth/_side-layout/settings_/privacy/server-events': typeof AuthSideLayoutSettingsPrivacyServerEventsRoute
  '/_auth/_side-layout/settings_/privacy/user-consent': typeof AuthSideLayoutSettingsPrivacyUserConsentRoute
  '/_auth/_side-layout/super-admin/data/agents': typeof AuthSideLayoutSuperAdminDataAgentsRoute
  '/_auth/_side-layout/super-admin/data/changes': typeof AuthSideLayoutSuperAdminDataChangesRoute
  '/_auth/_side-layout/super-admin/data/companies': typeof AuthSideLayoutSuperAdminDataCompaniesRoute
  '/_auth/_side-layout/super-admin/data/lookups': typeof AuthSideLayoutSuperAdminDataLookupsRoute
  '/_auth/_side-layout/super-admin/data/personas': typeof AuthSideLayoutSuperAdminDataPersonasRoute
  '/_auth/_side-layout/super-admin/enrichment/configuration': typeof AuthSideLayoutSuperAdminEnrichmentConfigurationRoute
  '/_auth/_side-layout/super-admin/enrichment/providers': typeof AuthSideLayoutSuperAdminEnrichmentProvidersRoute
  '/_auth/_side-layout/super-admin/visitor-id/configuration': typeof AuthSideLayoutSuperAdminVisitorIdConfigurationRoute
  '/_auth/_side-layout/super-admin/visitor-id/providers': typeof AuthSideLayoutSuperAdminVisitorIdProvidersRoute
  '/_auth/_side-layout/super-admin/visitor-id/regions': typeof AuthSideLayoutSuperAdminVisitorIdRegionsRoute
  '/_auth/_side-layout/super-admin/web-browsing/configuration': typeof AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute
  '/_auth/_side-layout/super-admin/web-browsing/providers': typeof AuthSideLayoutSuperAdminWebBrowsingProvidersRoute
  '/_auth/_side-layout/actions/profiles/': typeof AuthSideLayoutActionsProfilesIndexRoute
  '/_auth/_side-layout/actions/your-actions/': typeof AuthSideLayoutActionsYourActionsIndexRoute
  '/_auth/_side-layout/integrations/access/': typeof AuthSideLayoutIntegrationsAccessIndexRoute
  '/_auth/_side-layout/settings_/organization/': typeof AuthSideLayoutSettingsOrganizationIndexRoute
  '/_auth/_side-layout/settings_/privacy/': typeof AuthSideLayoutSettingsPrivacyIndexRoute
  '/_auth/_side-layout/super-admin/enrichment/': typeof AuthSideLayoutSuperAdminEnrichmentIndexRoute
  '/_auth/_side-layout/super-admin/visitor-id/': typeof AuthSideLayoutSuperAdminVisitorIdIndexRoute
  '/_auth/_side-layout/super-admin/web-browsing/': typeof AuthSideLayoutSuperAdminWebBrowsingIndexRoute
  '/_auth/_side-layout/actions/your-actions_/activity_/$runId': typeof AuthSideLayoutActionsYourActionsActivityRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/consent'
    | '/deal'
    | '/demo'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/accept-invitation'
    | '/claim'
    | '/onboarding'
    | '/shares/$dashboardId'
    | '/account'
    | '/start-tracking'
    | '/companies'
    | '/dashboard-share'
    | '/events'
    | '/funnels'
    | '/getting-started'
    | '/groups'
    | '/home'
    | '/journeys'
    | '/playground'
    | '/project-settings'
    | '/projects'
    | '/queries'
    | '/reports'
    | '/revenue'
    | '/search-console'
    | '/settings'
    | '/super-admin'
    | '/triggers'
    | '/upgrade'
    | '/users'
    | '/actions/catalog'
    | '/actions/profiles'
    | '/actions/signals'
    | '/actions/your-actions'
    | '/automations/api-keys'
    | '/automations/enrichment'
    | '/automations/robots'
    | '/companies/$companyId'
    | '/funnels/add-funnel-report'
    | '/integrations/$integrationId'
    | '/integrations/access'
    | '/integrations/connected'
    | '/journeys/add-journey-report'
    | '/payments/cancel'
    | '/payments/success'
    | '/project-settings/autocapture'
    | '/project-settings/consent'
    | '/project-settings/danger-zone'
    | '/project-settings/domains'
    | '/project-settings/filters'
    | '/project-settings/general'
    | '/project-settings/identity'
    | '/project-settings/integrations'
    | '/project-settings/playground'
    | '/project-settings/revenue'
    | '/project-settings/search-console'
    | '/projects/details'
    | '/reports/add-funnel-report'
    | '/settings/account'
    | '/settings/ai'
    | '/settings/billing'
    | '/settings/groups'
    | '/settings/identities'
    | '/settings/integrations'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/privacy'
    | '/settings/projects'
    | '/super-admin/crm'
    | '/super-admin/enrichment'
    | '/super-admin/features'
    | '/super-admin/privacy-requests'
    | '/super-admin/promos'
    | '/super-admin/subscriptions'
    | '/super-admin/users'
    | '/super-admin/visitor-id'
    | '/super-admin/web-browsing'
    | '/users/$userId'
    | '/actions/'
    | '/integrations/'
    | '/project-settings/'
    | '/super-admin/'
    | '/actions/profiles/personas'
    | '/actions/profiles/profiles'
    | '/actions/profiles/$profileId'
    | '/actions/your-actions/actions'
    | '/actions/your-actions/activity'
    | '/integrations/access/api'
    | '/integrations/access/mcp'
    | '/integrations/attio/callback'
    | '/integrations/hubspot/callback'
    | '/integrations/salesforce/callback'
    | '/integrations/slack/callback'
    | '/settings/identities/$identityId'
    | '/settings/organization/currency'
    | '/settings/organization/details'
    | '/settings/privacy/consent-sources'
    | '/settings/privacy/requests'
    | '/settings/privacy/server-events'
    | '/settings/privacy/user-consent'
    | '/super-admin/data/agents'
    | '/super-admin/data/changes'
    | '/super-admin/data/companies'
    | '/super-admin/data/lookups'
    | '/super-admin/data/personas'
    | '/super-admin/enrichment/configuration'
    | '/super-admin/enrichment/providers'
    | '/super-admin/visitor-id/configuration'
    | '/super-admin/visitor-id/providers'
    | '/super-admin/visitor-id/regions'
    | '/super-admin/web-browsing/configuration'
    | '/super-admin/web-browsing/providers'
    | '/actions/profiles/'
    | '/actions/your-actions/'
    | '/integrations/access/'
    | '/settings/organization/'
    | '/settings/privacy/'
    | '/super-admin/enrichment/'
    | '/super-admin/visitor-id/'
    | '/super-admin/web-browsing/'
    | '/actions/your-actions/activity/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/consent'
    | '/deal'
    | '/demo'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/accept-invitation'
    | '/claim'
    | '/onboarding'
    | '/shares/$dashboardId'
    | '/account'
    | '/start-tracking'
    | '/companies'
    | '/dashboard-share'
    | '/events'
    | '/funnels'
    | '/getting-started'
    | '/groups'
    | '/home'
    | '/journeys'
    | '/playground'
    | '/projects'
    | '/queries'
    | '/reports'
    | '/revenue'
    | '/search-console'
    | '/settings'
    | '/triggers'
    | '/upgrade'
    | '/users'
    | '/actions/catalog'
    | '/actions/signals'
    | '/automations/api-keys'
    | '/automations/enrichment'
    | '/automations/robots'
    | '/companies/$companyId'
    | '/funnels/add-funnel-report'
    | '/integrations/$integrationId'
    | '/integrations/connected'
    | '/journeys/add-journey-report'
    | '/payments/cancel'
    | '/payments/success'
    | '/project-settings/autocapture'
    | '/project-settings/consent'
    | '/project-settings/danger-zone'
    | '/project-settings/domains'
    | '/project-settings/filters'
    | '/project-settings/general'
    | '/project-settings/identity'
    | '/project-settings/integrations'
    | '/project-settings/playground'
    | '/project-settings/revenue'
    | '/project-settings/search-console'
    | '/projects/details'
    | '/reports/add-funnel-report'
    | '/settings/account'
    | '/settings/ai'
    | '/settings/billing'
    | '/settings/groups'
    | '/settings/identities'
    | '/settings/integrations'
    | '/settings/members'
    | '/settings/projects'
    | '/super-admin/crm'
    | '/super-admin/features'
    | '/super-admin/privacy-requests'
    | '/super-admin/promos'
    | '/super-admin/subscriptions'
    | '/super-admin/users'
    | '/users/$userId'
    | '/actions'
    | '/integrations'
    | '/project-settings'
    | '/super-admin'
    | '/actions/profiles/personas'
    | '/actions/profiles/profiles'
    | '/actions/profiles/$profileId'
    | '/actions/your-actions/actions'
    | '/actions/your-actions/activity'
    | '/integrations/access/api'
    | '/integrations/access/mcp'
    | '/integrations/attio/callback'
    | '/integrations/hubspot/callback'
    | '/integrations/salesforce/callback'
    | '/integrations/slack/callback'
    | '/settings/identities/$identityId'
    | '/settings/organization/currency'
    | '/settings/organization/details'
    | '/settings/privacy/consent-sources'
    | '/settings/privacy/requests'
    | '/settings/privacy/server-events'
    | '/settings/privacy/user-consent'
    | '/super-admin/data/agents'
    | '/super-admin/data/changes'
    | '/super-admin/data/companies'
    | '/super-admin/data/lookups'
    | '/super-admin/data/personas'
    | '/super-admin/enrichment/configuration'
    | '/super-admin/enrichment/providers'
    | '/super-admin/visitor-id/configuration'
    | '/super-admin/visitor-id/providers'
    | '/super-admin/visitor-id/regions'
    | '/super-admin/web-browsing/configuration'
    | '/super-admin/web-browsing/providers'
    | '/actions/profiles'
    | '/actions/your-actions'
    | '/integrations/access'
    | '/settings/organization'
    | '/settings/privacy'
    | '/super-admin/enrichment'
    | '/super-admin/visitor-id'
    | '/super-admin/web-browsing'
    | '/actions/your-actions/activity/$runId'
  id:
    | '__root__'
    | '/_auth'
    | '/consent'
    | '/deal'
    | '/demo'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/_auth/_basic-layout'
    | '/_auth/_side-layout'
    | '/_auth/accept-invitation'
    | '/_auth/claim'
    | '/_auth/onboarding'
    | '/shares/$dashboardId'
    | '/_auth/_basic-layout/account'
    | '/_auth/_basic-layout/start-tracking'
    | '/_auth/_side-layout/companies'
    | '/_auth/_side-layout/dashboard-share'
    | '/_auth/_side-layout/events'
    | '/_auth/_side-layout/funnels'
    | '/_auth/_side-layout/getting-started'
    | '/_auth/_side-layout/groups'
    | '/_auth/_side-layout/home'
    | '/_auth/_side-layout/journeys'
    | '/_auth/_side-layout/playground'
    | '/_auth/_side-layout/project-settings'
    | '/_auth/_side-layout/projects'
    | '/_auth/_side-layout/queries'
    | '/_auth/_side-layout/reports'
    | '/_auth/_side-layout/revenue'
    | '/_auth/_side-layout/search-console'
    | '/_auth/_side-layout/settings'
    | '/_auth/_side-layout/super-admin'
    | '/_auth/_side-layout/triggers'
    | '/_auth/_side-layout/upgrade'
    | '/_auth/_side-layout/users'
    | '/_auth/_side-layout/'
    | '/_auth/_side-layout/actions/catalog'
    | '/_auth/_side-layout/actions/profiles'
    | '/_auth/_side-layout/actions/signals'
    | '/_auth/_side-layout/actions/your-actions'
    | '/_auth/_side-layout/automations_/api-keys'
    | '/_auth/_side-layout/automations_/enrichment'
    | '/_auth/_side-layout/automations_/robots'
    | '/_auth/_side-layout/companies_/$companyId'
    | '/_auth/_side-layout/funnels_/add-funnel-report'
    | '/_auth/_side-layout/integrations/$integrationId'
    | '/_auth/_side-layout/integrations/access'
    | '/_auth/_side-layout/integrations/connected'
    | '/_auth/_side-layout/journeys_/add-journey-report'
    | '/_auth/_side-layout/payments/cancel'
    | '/_auth/_side-layout/payments/success'
    | '/_auth/_side-layout/project-settings/autocapture'
    | '/_auth/_side-layout/project-settings/consent'
    | '/_auth/_side-layout/project-settings/danger-zone'
    | '/_auth/_side-layout/project-settings/domains'
    | '/_auth/_side-layout/project-settings/filters'
    | '/_auth/_side-layout/project-settings/general'
    | '/_auth/_side-layout/project-settings/identity'
    | '/_auth/_side-layout/project-settings/integrations'
    | '/_auth/_side-layout/project-settings/playground'
    | '/_auth/_side-layout/project-settings/revenue'
    | '/_auth/_side-layout/project-settings/search-console'
    | '/_auth/_side-layout/projects_/details'
    | '/_auth/_side-layout/reports_/add-funnel-report'
    | '/_auth/_side-layout/settings_/account'
    | '/_auth/_side-layout/settings_/ai'
    | '/_auth/_side-layout/settings_/billing'
    | '/_auth/_side-layout/settings_/groups'
    | '/_auth/_side-layout/settings_/identities'
    | '/_auth/_side-layout/settings_/integrations'
    | '/_auth/_side-layout/settings_/members'
    | '/_auth/_side-layout/settings_/organization'
    | '/_auth/_side-layout/settings_/privacy'
    | '/_auth/_side-layout/settings_/projects'
    | '/_auth/_side-layout/super-admin/crm'
    | '/_auth/_side-layout/super-admin/enrichment'
    | '/_auth/_side-layout/super-admin/features'
    | '/_auth/_side-layout/super-admin/privacy-requests'
    | '/_auth/_side-layout/super-admin/promos'
    | '/_auth/_side-layout/super-admin/subscriptions'
    | '/_auth/_side-layout/super-admin/users'
    | '/_auth/_side-layout/super-admin/visitor-id'
    | '/_auth/_side-layout/super-admin/web-browsing'
    | '/_auth/_side-layout/users_/$userId'
    | '/_auth/_side-layout/actions/'
    | '/_auth/_side-layout/integrations/'
    | '/_auth/_side-layout/project-settings/'
    | '/_auth/_side-layout/super-admin/'
    | '/_auth/_side-layout/actions/profiles/personas'
    | '/_auth/_side-layout/actions/profiles/profiles'
    | '/_auth/_side-layout/actions/profiles_/$profileId'
    | '/_auth/_side-layout/actions/your-actions/actions'
    | '/_auth/_side-layout/actions/your-actions/activity'
    | '/_auth/_side-layout/integrations/access/api'
    | '/_auth/_side-layout/integrations/access/mcp'
    | '/_auth/_side-layout/integrations/attio/callback'
    | '/_auth/_side-layout/integrations/hubspot/callback'
    | '/_auth/_side-layout/integrations/salesforce/callback'
    | '/_auth/_side-layout/integrations/slack/callback'
    | '/_auth/_side-layout/settings_/identities_/$identityId'
    | '/_auth/_side-layout/settings_/organization/currency'
    | '/_auth/_side-layout/settings_/organization/details'
    | '/_auth/_side-layout/settings_/privacy/consent-sources'
    | '/_auth/_side-layout/settings_/privacy/requests'
    | '/_auth/_side-layout/settings_/privacy/server-events'
    | '/_auth/_side-layout/settings_/privacy/user-consent'
    | '/_auth/_side-layout/super-admin/data/agents'
    | '/_auth/_side-layout/super-admin/data/changes'
    | '/_auth/_side-layout/super-admin/data/companies'
    | '/_auth/_side-layout/super-admin/data/lookups'
    | '/_auth/_side-layout/super-admin/data/personas'
    | '/_auth/_side-layout/super-admin/enrichment/configuration'
    | '/_auth/_side-layout/super-admin/enrichment/providers'
    | '/_auth/_side-layout/super-admin/visitor-id/configuration'
    | '/_auth/_side-layout/super-admin/visitor-id/providers'
    | '/_auth/_side-layout/super-admin/visitor-id/regions'
    | '/_auth/_side-layout/super-admin/web-browsing/configuration'
    | '/_auth/_side-layout/super-admin/web-browsing/providers'
    | '/_auth/_side-layout/actions/profiles/'
    | '/_auth/_side-layout/actions/your-actions/'
    | '/_auth/_side-layout/integrations/access/'
    | '/_auth/_side-layout/settings_/organization/'
    | '/_auth/_side-layout/settings_/privacy/'
    | '/_auth/_side-layout/super-admin/enrichment/'
    | '/_auth/_side-layout/super-admin/visitor-id/'
    | '/_auth/_side-layout/super-admin/web-browsing/'
    | '/_auth/_side-layout/actions/your-actions_/activity_/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ConsentRoute: typeof ConsentRoute
  DealRoute: typeof DealRoute
  DemoRoute: typeof DemoRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  SharesDashboardIdRoute: typeof SharesDashboardIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deal': {
      id: '/deal'
      path: '/deal'
      fullPath: '/deal'
      preLoaderRoute: typeof DealRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_basic-layout': {
      id: '/_auth/_basic-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthBasicLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_side-layout': {
      id: '/_auth/_side-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthSideLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accept-invitation': {
      id: '/_auth/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/claim': {
      id: '/_auth/claim'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof AuthClaimRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/shares/$dashboardId': {
      id: '/shares/$dashboardId'
      path: '/shares/$dashboardId'
      fullPath: '/shares/$dashboardId'
      preLoaderRoute: typeof SharesDashboardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_basic-layout/account': {
      id: '/_auth/_basic-layout/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthBasicLayoutAccountRouteImport
      parentRoute: typeof AuthBasicLayoutRoute
    }
    '/_auth/_basic-layout/start-tracking': {
      id: '/_auth/_basic-layout/start-tracking'
      path: '/start-tracking'
      fullPath: '/start-tracking'
      preLoaderRoute: typeof AuthBasicLayoutStartTrackingRouteImport
      parentRoute: typeof AuthBasicLayoutRoute
    }
    '/_auth/_side-layout/': {
      id: '/_auth/_side-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthSideLayoutIndexRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/companies': {
      id: '/_auth/_side-layout/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthSideLayoutCompaniesRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/dashboard-share': {
      id: '/_auth/_side-layout/dashboard-share'
      path: '/dashboard-share'
      fullPath: '/dashboard-share'
      preLoaderRoute: typeof AuthSideLayoutDashboardShareRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/events': {
      id: '/_auth/_side-layout/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthSideLayoutEventsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/funnels': {
      id: '/_auth/_side-layout/funnels'
      path: '/funnels'
      fullPath: '/funnels'
      preLoaderRoute: typeof AuthSideLayoutFunnelsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/getting-started': {
      id: '/_auth/_side-layout/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AuthSideLayoutGettingStartedRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/groups': {
      id: '/_auth/_side-layout/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthSideLayoutGroupsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/home': {
      id: '/_auth/_side-layout/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthSideLayoutHomeRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/journeys': {
      id: '/_auth/_side-layout/journeys'
      path: '/journeys'
      fullPath: '/journeys'
      preLoaderRoute: typeof AuthSideLayoutJourneysRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/playground': {
      id: '/_auth/_side-layout/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof AuthSideLayoutPlaygroundRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/project-settings': {
      id: '/_auth/_side-layout/project-settings'
      path: '/project-settings'
      fullPath: '/project-settings'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/projects': {
      id: '/_auth/_side-layout/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthSideLayoutProjectsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/queries': {
      id: '/_auth/_side-layout/queries'
      path: '/queries'
      fullPath: '/queries'
      preLoaderRoute: typeof AuthSideLayoutQueriesRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/reports': {
      id: '/_auth/_side-layout/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthSideLayoutReportsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/revenue': {
      id: '/_auth/_side-layout/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof AuthSideLayoutRevenueRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/search-console': {
      id: '/_auth/_side-layout/search-console'
      path: '/search-console'
      fullPath: '/search-console'
      preLoaderRoute: typeof AuthSideLayoutSearchConsoleRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings': {
      id: '/_auth/_side-layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSideLayoutSettingsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/super-admin': {
      id: '/_auth/_side-layout/super-admin'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/triggers': {
      id: '/_auth/_side-layout/triggers'
      path: '/triggers'
      fullPath: '/triggers'
      preLoaderRoute: typeof AuthSideLayoutTriggersRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/upgrade': {
      id: '/_auth/_side-layout/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthSideLayoutUpgradeRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/users': {
      id: '/_auth/_side-layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthSideLayoutUsersRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/': {
      id: '/_auth/_side-layout/actions/'
      path: '/actions'
      fullPath: '/actions/'
      preLoaderRoute: typeof AuthSideLayoutActionsIndexRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/catalog': {
      id: '/_auth/_side-layout/actions/catalog'
      path: '/actions/catalog'
      fullPath: '/actions/catalog'
      preLoaderRoute: typeof AuthSideLayoutActionsCatalogRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/profiles': {
      id: '/_auth/_side-layout/actions/profiles'
      path: '/actions/profiles'
      fullPath: '/actions/profiles'
      preLoaderRoute: typeof AuthSideLayoutActionsProfilesRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/signals': {
      id: '/_auth/_side-layout/actions/signals'
      path: '/actions/signals'
      fullPath: '/actions/signals'
      preLoaderRoute: typeof AuthSideLayoutActionsSignalsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/your-actions': {
      id: '/_auth/_side-layout/actions/your-actions'
      path: '/actions/your-actions'
      fullPath: '/actions/your-actions'
      preLoaderRoute: typeof AuthSideLayoutActionsYourActionsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/automations_/api-keys': {
      id: '/_auth/_side-layout/automations_/api-keys'
      path: '/automations/api-keys'
      fullPath: '/automations/api-keys'
      preLoaderRoute: typeof AuthSideLayoutAutomationsApiKeysRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/automations_/enrichment': {
      id: '/_auth/_side-layout/automations_/enrichment'
      path: '/automations/enrichment'
      fullPath: '/automations/enrichment'
      preLoaderRoute: typeof AuthSideLayoutAutomationsEnrichmentRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/automations_/robots': {
      id: '/_auth/_side-layout/automations_/robots'
      path: '/automations/robots'
      fullPath: '/automations/robots'
      preLoaderRoute: typeof AuthSideLayoutAutomationsRobotsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/companies_/$companyId': {
      id: '/_auth/_side-layout/companies_/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthSideLayoutCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/funnels_/add-funnel-report': {
      id: '/_auth/_side-layout/funnels_/add-funnel-report'
      path: '/funnels/add-funnel-report'
      fullPath: '/funnels/add-funnel-report'
      preLoaderRoute: typeof AuthSideLayoutFunnelsAddFunnelReportRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/': {
      id: '/_auth/_side-layout/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsIndexRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/$integrationId': {
      id: '/_auth/_side-layout/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/integrations/$integrationId'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsIntegrationIdRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/access': {
      id: '/_auth/_side-layout/integrations/access'
      path: '/integrations/access'
      fullPath: '/integrations/access'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsAccessRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/connected': {
      id: '/_auth/_side-layout/integrations/connected'
      path: '/integrations/connected'
      fullPath: '/integrations/connected'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsConnectedRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/journeys_/add-journey-report': {
      id: '/_auth/_side-layout/journeys_/add-journey-report'
      path: '/journeys/add-journey-report'
      fullPath: '/journeys/add-journey-report'
      preLoaderRoute: typeof AuthSideLayoutJourneysAddJourneyReportRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/payments/cancel': {
      id: '/_auth/_side-layout/payments/cancel'
      path: '/payments/cancel'
      fullPath: '/payments/cancel'
      preLoaderRoute: typeof AuthSideLayoutPaymentsCancelRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/payments/success': {
      id: '/_auth/_side-layout/payments/success'
      path: '/payments/success'
      fullPath: '/payments/success'
      preLoaderRoute: typeof AuthSideLayoutPaymentsSuccessRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/project-settings/': {
      id: '/_auth/_side-layout/project-settings/'
      path: '/'
      fullPath: '/project-settings/'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsIndexRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/autocapture': {
      id: '/_auth/_side-layout/project-settings/autocapture'
      path: '/autocapture'
      fullPath: '/project-settings/autocapture'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsAutocaptureRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/consent': {
      id: '/_auth/_side-layout/project-settings/consent'
      path: '/consent'
      fullPath: '/project-settings/consent'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsConsentRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/danger-zone': {
      id: '/_auth/_side-layout/project-settings/danger-zone'
      path: '/danger-zone'
      fullPath: '/project-settings/danger-zone'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsDangerZoneRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/domains': {
      id: '/_auth/_side-layout/project-settings/domains'
      path: '/domains'
      fullPath: '/project-settings/domains'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsDomainsRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/filters': {
      id: '/_auth/_side-layout/project-settings/filters'
      path: '/filters'
      fullPath: '/project-settings/filters'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsFiltersRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/general': {
      id: '/_auth/_side-layout/project-settings/general'
      path: '/general'
      fullPath: '/project-settings/general'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsGeneralRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/identity': {
      id: '/_auth/_side-layout/project-settings/identity'
      path: '/identity'
      fullPath: '/project-settings/identity'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsIdentityRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/integrations': {
      id: '/_auth/_side-layout/project-settings/integrations'
      path: '/integrations'
      fullPath: '/project-settings/integrations'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsIntegrationsRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/playground': {
      id: '/_auth/_side-layout/project-settings/playground'
      path: '/playground'
      fullPath: '/project-settings/playground'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsPlaygroundRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/revenue': {
      id: '/_auth/_side-layout/project-settings/revenue'
      path: '/revenue'
      fullPath: '/project-settings/revenue'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsRevenueRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/project-settings/search-console': {
      id: '/_auth/_side-layout/project-settings/search-console'
      path: '/search-console'
      fullPath: '/project-settings/search-console'
      preLoaderRoute: typeof AuthSideLayoutProjectSettingsSearchConsoleRouteImport
      parentRoute: typeof AuthSideLayoutProjectSettingsRoute
    }
    '/_auth/_side-layout/projects_/details': {
      id: '/_auth/_side-layout/projects_/details'
      path: '/projects/details'
      fullPath: '/projects/details'
      preLoaderRoute: typeof AuthSideLayoutProjectsDetailsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/reports_/add-funnel-report': {
      id: '/_auth/_side-layout/reports_/add-funnel-report'
      path: '/reports/add-funnel-report'
      fullPath: '/reports/add-funnel-report'
      preLoaderRoute: typeof AuthSideLayoutReportsAddFunnelReportRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/account': {
      id: '/_auth/_side-layout/settings_/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthSideLayoutSettingsAccountRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/ai': {
      id: '/_auth/_side-layout/settings_/ai'
      path: '/settings/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof AuthSideLayoutSettingsAiRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/billing': {
      id: '/_auth/_side-layout/settings_/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthSideLayoutSettingsBillingRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/groups': {
      id: '/_auth/_side-layout/settings_/groups'
      path: '/settings/groups'
      fullPath: '/settings/groups'
      preLoaderRoute: typeof AuthSideLayoutSettingsGroupsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/identities': {
      id: '/_auth/_side-layout/settings_/identities'
      path: '/settings/identities'
      fullPath: '/settings/identities'
      preLoaderRoute: typeof AuthSideLayoutSettingsIdentitiesRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/integrations': {
      id: '/_auth/_side-layout/settings_/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthSideLayoutSettingsIntegrationsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/members': {
      id: '/_auth/_side-layout/settings_/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthSideLayoutSettingsMembersRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/organization': {
      id: '/_auth/_side-layout/settings_/organization'
      path: '/settings/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthSideLayoutSettingsOrganizationRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/privacy': {
      id: '/_auth/_side-layout/settings_/privacy'
      path: '/settings/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AuthSideLayoutSettingsPrivacyRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/projects': {
      id: '/_auth/_side-layout/settings_/projects'
      path: '/settings/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof AuthSideLayoutSettingsProjectsRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/super-admin/': {
      id: '/_auth/_side-layout/super-admin/'
      path: '/'
      fullPath: '/super-admin/'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminIndexRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/crm': {
      id: '/_auth/_side-layout/super-admin/crm'
      path: '/crm'
      fullPath: '/super-admin/crm'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminCrmRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/enrichment': {
      id: '/_auth/_side-layout/super-admin/enrichment'
      path: '/enrichment'
      fullPath: '/super-admin/enrichment'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminEnrichmentRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/features': {
      id: '/_auth/_side-layout/super-admin/features'
      path: '/features'
      fullPath: '/super-admin/features'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminFeaturesRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/privacy-requests': {
      id: '/_auth/_side-layout/super-admin/privacy-requests'
      path: '/privacy-requests'
      fullPath: '/super-admin/privacy-requests'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminPrivacyRequestsRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/promos': {
      id: '/_auth/_side-layout/super-admin/promos'
      path: '/promos'
      fullPath: '/super-admin/promos'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminPromosRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/subscriptions': {
      id: '/_auth/_side-layout/super-admin/subscriptions'
      path: '/subscriptions'
      fullPath: '/super-admin/subscriptions'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminSubscriptionsRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/users': {
      id: '/_auth/_side-layout/super-admin/users'
      path: '/users'
      fullPath: '/super-admin/users'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminUsersRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/visitor-id': {
      id: '/_auth/_side-layout/super-admin/visitor-id'
      path: '/visitor-id'
      fullPath: '/super-admin/visitor-id'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminVisitorIdRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/web-browsing': {
      id: '/_auth/_side-layout/super-admin/web-browsing'
      path: '/web-browsing'
      fullPath: '/super-admin/web-browsing'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminWebBrowsingRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/users_/$userId': {
      id: '/_auth/_side-layout/users_/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthSideLayoutUsersUserIdRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/profiles/': {
      id: '/_auth/_side-layout/actions/profiles/'
      path: '/'
      fullPath: '/actions/profiles/'
      preLoaderRoute: typeof AuthSideLayoutActionsProfilesIndexRouteImport
      parentRoute: typeof AuthSideLayoutActionsProfilesRoute
    }
    '/_auth/_side-layout/actions/profiles/personas': {
      id: '/_auth/_side-layout/actions/profiles/personas'
      path: '/personas'
      fullPath: '/actions/profiles/personas'
      preLoaderRoute: typeof AuthSideLayoutActionsProfilesPersonasRouteImport
      parentRoute: typeof AuthSideLayoutActionsProfilesRoute
    }
    '/_auth/_side-layout/actions/profiles/profiles': {
      id: '/_auth/_side-layout/actions/profiles/profiles'
      path: '/profiles'
      fullPath: '/actions/profiles/profiles'
      preLoaderRoute: typeof AuthSideLayoutActionsProfilesProfilesRouteImport
      parentRoute: typeof AuthSideLayoutActionsProfilesRoute
    }
    '/_auth/_side-layout/actions/profiles_/$profileId': {
      id: '/_auth/_side-layout/actions/profiles_/$profileId'
      path: '/actions/profiles/$profileId'
      fullPath: '/actions/profiles/$profileId'
      preLoaderRoute: typeof AuthSideLayoutActionsProfilesProfileIdRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/actions/your-actions/': {
      id: '/_auth/_side-layout/actions/your-actions/'
      path: '/'
      fullPath: '/actions/your-actions/'
      preLoaderRoute: typeof AuthSideLayoutActionsYourActionsIndexRouteImport
      parentRoute: typeof AuthSideLayoutActionsYourActionsRoute
    }
    '/_auth/_side-layout/actions/your-actions/actions': {
      id: '/_auth/_side-layout/actions/your-actions/actions'
      path: '/actions'
      fullPath: '/actions/your-actions/actions'
      preLoaderRoute: typeof AuthSideLayoutActionsYourActionsActionsRouteImport
      parentRoute: typeof AuthSideLayoutActionsYourActionsRoute
    }
    '/_auth/_side-layout/actions/your-actions/activity': {
      id: '/_auth/_side-layout/actions/your-actions/activity'
      path: '/activity'
      fullPath: '/actions/your-actions/activity'
      preLoaderRoute: typeof AuthSideLayoutActionsYourActionsActivityRouteImport
      parentRoute: typeof AuthSideLayoutActionsYourActionsRoute
    }
    '/_auth/_side-layout/integrations/access/': {
      id: '/_auth/_side-layout/integrations/access/'
      path: '/'
      fullPath: '/integrations/access/'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsAccessIndexRouteImport
      parentRoute: typeof AuthSideLayoutIntegrationsAccessRoute
    }
    '/_auth/_side-layout/integrations/access/api': {
      id: '/_auth/_side-layout/integrations/access/api'
      path: '/api'
      fullPath: '/integrations/access/api'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsAccessApiRouteImport
      parentRoute: typeof AuthSideLayoutIntegrationsAccessRoute
    }
    '/_auth/_side-layout/integrations/access/mcp': {
      id: '/_auth/_side-layout/integrations/access/mcp'
      path: '/mcp'
      fullPath: '/integrations/access/mcp'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsAccessMcpRouteImport
      parentRoute: typeof AuthSideLayoutIntegrationsAccessRoute
    }
    '/_auth/_side-layout/integrations/attio/callback': {
      id: '/_auth/_side-layout/integrations/attio/callback'
      path: '/integrations/attio/callback'
      fullPath: '/integrations/attio/callback'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsAttioCallbackRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/hubspot/callback': {
      id: '/_auth/_side-layout/integrations/hubspot/callback'
      path: '/integrations/hubspot/callback'
      fullPath: '/integrations/hubspot/callback'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsHubspotCallbackRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/salesforce/callback': {
      id: '/_auth/_side-layout/integrations/salesforce/callback'
      path: '/integrations/salesforce/callback'
      fullPath: '/integrations/salesforce/callback'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsSalesforceCallbackRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/integrations/slack/callback': {
      id: '/_auth/_side-layout/integrations/slack/callback'
      path: '/integrations/slack/callback'
      fullPath: '/integrations/slack/callback'
      preLoaderRoute: typeof AuthSideLayoutIntegrationsSlackCallbackRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/identities_/$identityId': {
      id: '/_auth/_side-layout/settings_/identities_/$identityId'
      path: '/settings/identities/$identityId'
      fullPath: '/settings/identities/$identityId'
      preLoaderRoute: typeof AuthSideLayoutSettingsIdentitiesIdentityIdRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
    '/_auth/_side-layout/settings_/organization/': {
      id: '/_auth/_side-layout/settings_/organization/'
      path: '/'
      fullPath: '/settings/organization/'
      preLoaderRoute: typeof AuthSideLayoutSettingsOrganizationIndexRouteImport
      parentRoute: typeof AuthSideLayoutSettingsOrganizationRoute
    }
    '/_auth/_side-layout/settings_/organization/currency': {
      id: '/_auth/_side-layout/settings_/organization/currency'
      path: '/currency'
      fullPath: '/settings/organization/currency'
      preLoaderRoute: typeof AuthSideLayoutSettingsOrganizationCurrencyRouteImport
      parentRoute: typeof AuthSideLayoutSettingsOrganizationRoute
    }
    '/_auth/_side-layout/settings_/organization/details': {
      id: '/_auth/_side-layout/settings_/organization/details'
      path: '/details'
      fullPath: '/settings/organization/details'
      preLoaderRoute: typeof AuthSideLayoutSettingsOrganizationDetailsRouteImport
      parentRoute: typeof AuthSideLayoutSettingsOrganizationRoute
    }
    '/_auth/_side-layout/settings_/privacy/': {
      id: '/_auth/_side-layout/settings_/privacy/'
      path: '/'
      fullPath: '/settings/privacy/'
      preLoaderRoute: typeof AuthSideLayoutSettingsPrivacyIndexRouteImport
      parentRoute: typeof AuthSideLayoutSettingsPrivacyRoute
    }
    '/_auth/_side-layout/settings_/privacy/consent-sources': {
      id: '/_auth/_side-layout/settings_/privacy/consent-sources'
      path: '/consent-sources'
      fullPath: '/settings/privacy/consent-sources'
      preLoaderRoute: typeof AuthSideLayoutSettingsPrivacyConsentSourcesRouteImport
      parentRoute: typeof AuthSideLayoutSettingsPrivacyRoute
    }
    '/_auth/_side-layout/settings_/privacy/requests': {
      id: '/_auth/_side-layout/settings_/privacy/requests'
      path: '/requests'
      fullPath: '/settings/privacy/requests'
      preLoaderRoute: typeof AuthSideLayoutSettingsPrivacyRequestsRouteImport
      parentRoute: typeof AuthSideLayoutSettingsPrivacyRoute
    }
    '/_auth/_side-layout/settings_/privacy/server-events': {
      id: '/_auth/_side-layout/settings_/privacy/server-events'
      path: '/server-events'
      fullPath: '/settings/privacy/server-events'
      preLoaderRoute: typeof AuthSideLayoutSettingsPrivacyServerEventsRouteImport
      parentRoute: typeof AuthSideLayoutSettingsPrivacyRoute
    }
    '/_auth/_side-layout/settings_/privacy/user-consent': {
      id: '/_auth/_side-layout/settings_/privacy/user-consent'
      path: '/user-consent'
      fullPath: '/settings/privacy/user-consent'
      preLoaderRoute: typeof AuthSideLayoutSettingsPrivacyUserConsentRouteImport
      parentRoute: typeof AuthSideLayoutSettingsPrivacyRoute
    }
    '/_auth/_side-layout/super-admin/data/agents': {
      id: '/_auth/_side-layout/super-admin/data/agents'
      path: '/data/agents'
      fullPath: '/super-admin/data/agents'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminDataAgentsRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/data/changes': {
      id: '/_auth/_side-layout/super-admin/data/changes'
      path: '/data/changes'
      fullPath: '/super-admin/data/changes'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminDataChangesRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/data/companies': {
      id: '/_auth/_side-layout/super-admin/data/companies'
      path: '/data/companies'
      fullPath: '/super-admin/data/companies'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminDataCompaniesRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/data/lookups': {
      id: '/_auth/_side-layout/super-admin/data/lookups'
      path: '/data/lookups'
      fullPath: '/super-admin/data/lookups'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminDataLookupsRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/data/personas': {
      id: '/_auth/_side-layout/super-admin/data/personas'
      path: '/data/personas'
      fullPath: '/super-admin/data/personas'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminDataPersonasRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminRoute
    }
    '/_auth/_side-layout/super-admin/enrichment/': {
      id: '/_auth/_side-layout/super-admin/enrichment/'
      path: '/'
      fullPath: '/super-admin/enrichment/'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminEnrichmentIndexRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminEnrichmentRoute
    }
    '/_auth/_side-layout/super-admin/enrichment/configuration': {
      id: '/_auth/_side-layout/super-admin/enrichment/configuration'
      path: '/configuration'
      fullPath: '/super-admin/enrichment/configuration'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminEnrichmentConfigurationRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminEnrichmentRoute
    }
    '/_auth/_side-layout/super-admin/enrichment/providers': {
      id: '/_auth/_side-layout/super-admin/enrichment/providers'
      path: '/providers'
      fullPath: '/super-admin/enrichment/providers'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminEnrichmentProvidersRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminEnrichmentRoute
    }
    '/_auth/_side-layout/super-admin/visitor-id/': {
      id: '/_auth/_side-layout/super-admin/visitor-id/'
      path: '/'
      fullPath: '/super-admin/visitor-id/'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminVisitorIdIndexRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminVisitorIdRoute
    }
    '/_auth/_side-layout/super-admin/visitor-id/configuration': {
      id: '/_auth/_side-layout/super-admin/visitor-id/configuration'
      path: '/configuration'
      fullPath: '/super-admin/visitor-id/configuration'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminVisitorIdConfigurationRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminVisitorIdRoute
    }
    '/_auth/_side-layout/super-admin/visitor-id/providers': {
      id: '/_auth/_side-layout/super-admin/visitor-id/providers'
      path: '/providers'
      fullPath: '/super-admin/visitor-id/providers'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminVisitorIdProvidersRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminVisitorIdRoute
    }
    '/_auth/_side-layout/super-admin/visitor-id/regions': {
      id: '/_auth/_side-layout/super-admin/visitor-id/regions'
      path: '/regions'
      fullPath: '/super-admin/visitor-id/regions'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminVisitorIdRegionsRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminVisitorIdRoute
    }
    '/_auth/_side-layout/super-admin/web-browsing/': {
      id: '/_auth/_side-layout/super-admin/web-browsing/'
      path: '/'
      fullPath: '/super-admin/web-browsing/'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminWebBrowsingIndexRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminWebBrowsingRoute
    }
    '/_auth/_side-layout/super-admin/web-browsing/configuration': {
      id: '/_auth/_side-layout/super-admin/web-browsing/configuration'
      path: '/configuration'
      fullPath: '/super-admin/web-browsing/configuration'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminWebBrowsingConfigurationRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminWebBrowsingRoute
    }
    '/_auth/_side-layout/super-admin/web-browsing/providers': {
      id: '/_auth/_side-layout/super-admin/web-browsing/providers'
      path: '/providers'
      fullPath: '/super-admin/web-browsing/providers'
      preLoaderRoute: typeof AuthSideLayoutSuperAdminWebBrowsingProvidersRouteImport
      parentRoute: typeof AuthSideLayoutSuperAdminWebBrowsingRoute
    }
    '/_auth/_side-layout/actions/your-actions_/activity_/$runId': {
      id: '/_auth/_side-layout/actions/your-actions_/activity_/$runId'
      path: '/actions/your-actions/activity/$runId'
      fullPath: '/actions/your-actions/activity/$runId'
      preLoaderRoute: typeof AuthSideLayoutActionsYourActionsActivityRunIdRouteImport
      parentRoute: typeof AuthSideLayoutRoute
    }
  }
}

interface AuthBasicLayoutRouteChildren {
  AuthBasicLayoutAccountRoute: typeof AuthBasicLayoutAccountRoute
  AuthBasicLayoutStartTrackingRoute: typeof AuthBasicLayoutStartTrackingRoute
}

const AuthBasicLayoutRouteChildren: AuthBasicLayoutRouteChildren = {
  AuthBasicLayoutAccountRoute: AuthBasicLayoutAccountRoute,
  AuthBasicLayoutStartTrackingRoute: AuthBasicLayoutStartTrackingRoute,
}

const AuthBasicLayoutRouteWithChildren = AuthBasicLayoutRoute._addFileChildren(
  AuthBasicLayoutRouteChildren,
)

interface AuthSideLayoutProjectSettingsRouteChildren {
  AuthSideLayoutProjectSettingsAutocaptureRoute: typeof AuthSideLayoutProjectSettingsAutocaptureRoute
  AuthSideLayoutProjectSettingsConsentRoute: typeof AuthSideLayoutProjectSettingsConsentRoute
  AuthSideLayoutProjectSettingsDangerZoneRoute: typeof AuthSideLayoutProjectSettingsDangerZoneRoute
  AuthSideLayoutProjectSettingsDomainsRoute: typeof AuthSideLayoutProjectSettingsDomainsRoute
  AuthSideLayoutProjectSettingsFiltersRoute: typeof AuthSideLayoutProjectSettingsFiltersRoute
  AuthSideLayoutProjectSettingsGeneralRoute: typeof AuthSideLayoutProjectSettingsGeneralRoute
  AuthSideLayoutProjectSettingsIdentityRoute: typeof AuthSideLayoutProjectSettingsIdentityRoute
  AuthSideLayoutProjectSettingsIntegrationsRoute: typeof AuthSideLayoutProjectSettingsIntegrationsRoute
  AuthSideLayoutProjectSettingsPlaygroundRoute: typeof AuthSideLayoutProjectSettingsPlaygroundRoute
  AuthSideLayoutProjectSettingsRevenueRoute: typeof AuthSideLayoutProjectSettingsRevenueRoute
  AuthSideLayoutProjectSettingsSearchConsoleRoute: typeof AuthSideLayoutProjectSettingsSearchConsoleRoute
  AuthSideLayoutProjectSettingsIndexRoute: typeof AuthSideLayoutProjectSettingsIndexRoute
}

const AuthSideLayoutProjectSettingsRouteChildren: AuthSideLayoutProjectSettingsRouteChildren =
  {
    AuthSideLayoutProjectSettingsAutocaptureRoute:
      AuthSideLayoutProjectSettingsAutocaptureRoute,
    AuthSideLayoutProjectSettingsConsentRoute:
      AuthSideLayoutProjectSettingsConsentRoute,
    AuthSideLayoutProjectSettingsDangerZoneRoute:
      AuthSideLayoutProjectSettingsDangerZoneRoute,
    AuthSideLayoutProjectSettingsDomainsRoute:
      AuthSideLayoutProjectSettingsDomainsRoute,
    AuthSideLayoutProjectSettingsFiltersRoute:
      AuthSideLayoutProjectSettingsFiltersRoute,
    AuthSideLayoutProjectSettingsGeneralRoute:
      AuthSideLayoutProjectSettingsGeneralRoute,
    AuthSideLayoutProjectSettingsIdentityRoute:
      AuthSideLayoutProjectSettingsIdentityRoute,
    AuthSideLayoutProjectSettingsIntegrationsRoute:
      AuthSideLayoutProjectSettingsIntegrationsRoute,
    AuthSideLayoutProjectSettingsPlaygroundRoute:
      AuthSideLayoutProjectSettingsPlaygroundRoute,
    AuthSideLayoutProjectSettingsRevenueRoute:
      AuthSideLayoutProjectSettingsRevenueRoute,
    AuthSideLayoutProjectSettingsSearchConsoleRoute:
      AuthSideLayoutProjectSettingsSearchConsoleRoute,
    AuthSideLayoutProjectSettingsIndexRoute:
      AuthSideLayoutProjectSettingsIndexRoute,
  }

const AuthSideLayoutProjectSettingsRouteWithChildren =
  AuthSideLayoutProjectSettingsRoute._addFileChildren(
    AuthSideLayoutProjectSettingsRouteChildren,
  )

interface AuthSideLayoutSuperAdminEnrichmentRouteChildren {
  AuthSideLayoutSuperAdminEnrichmentConfigurationRoute: typeof AuthSideLayoutSuperAdminEnrichmentConfigurationRoute
  AuthSideLayoutSuperAdminEnrichmentProvidersRoute: typeof AuthSideLayoutSuperAdminEnrichmentProvidersRoute
  AuthSideLayoutSuperAdminEnrichmentIndexRoute: typeof AuthSideLayoutSuperAdminEnrichmentIndexRoute
}

const AuthSideLayoutSuperAdminEnrichmentRouteChildren: AuthSideLayoutSuperAdminEnrichmentRouteChildren =
  {
    AuthSideLayoutSuperAdminEnrichmentConfigurationRoute:
      AuthSideLayoutSuperAdminEnrichmentConfigurationRoute,
    AuthSideLayoutSuperAdminEnrichmentProvidersRoute:
      AuthSideLayoutSuperAdminEnrichmentProvidersRoute,
    AuthSideLayoutSuperAdminEnrichmentIndexRoute:
      AuthSideLayoutSuperAdminEnrichmentIndexRoute,
  }

const AuthSideLayoutSuperAdminEnrichmentRouteWithChildren =
  AuthSideLayoutSuperAdminEnrichmentRoute._addFileChildren(
    AuthSideLayoutSuperAdminEnrichmentRouteChildren,
  )

interface AuthSideLayoutSuperAdminVisitorIdRouteChildren {
  AuthSideLayoutSuperAdminVisitorIdConfigurationRoute: typeof AuthSideLayoutSuperAdminVisitorIdConfigurationRoute
  AuthSideLayoutSuperAdminVisitorIdProvidersRoute: typeof AuthSideLayoutSuperAdminVisitorIdProvidersRoute
  AuthSideLayoutSuperAdminVisitorIdRegionsRoute: typeof AuthSideLayoutSuperAdminVisitorIdRegionsRoute
  AuthSideLayoutSuperAdminVisitorIdIndexRoute: typeof AuthSideLayoutSuperAdminVisitorIdIndexRoute
}

const AuthSideLayoutSuperAdminVisitorIdRouteChildren: AuthSideLayoutSuperAdminVisitorIdRouteChildren =
  {
    AuthSideLayoutSuperAdminVisitorIdConfigurationRoute:
      AuthSideLayoutSuperAdminVisitorIdConfigurationRoute,
    AuthSideLayoutSuperAdminVisitorIdProvidersRoute:
      AuthSideLayoutSuperAdminVisitorIdProvidersRoute,
    AuthSideLayoutSuperAdminVisitorIdRegionsRoute:
      AuthSideLayoutSuperAdminVisitorIdRegionsRoute,
    AuthSideLayoutSuperAdminVisitorIdIndexRoute:
      AuthSideLayoutSuperAdminVisitorIdIndexRoute,
  }

const AuthSideLayoutSuperAdminVisitorIdRouteWithChildren =
  AuthSideLayoutSuperAdminVisitorIdRoute._addFileChildren(
    AuthSideLayoutSuperAdminVisitorIdRouteChildren,
  )

interface AuthSideLayoutSuperAdminWebBrowsingRouteChildren {
  AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute: typeof AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute
  AuthSideLayoutSuperAdminWebBrowsingProvidersRoute: typeof AuthSideLayoutSuperAdminWebBrowsingProvidersRoute
  AuthSideLayoutSuperAdminWebBrowsingIndexRoute: typeof AuthSideLayoutSuperAdminWebBrowsingIndexRoute
}

const AuthSideLayoutSuperAdminWebBrowsingRouteChildren: AuthSideLayoutSuperAdminWebBrowsingRouteChildren =
  {
    AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute:
      AuthSideLayoutSuperAdminWebBrowsingConfigurationRoute,
    AuthSideLayoutSuperAdminWebBrowsingProvidersRoute:
      AuthSideLayoutSuperAdminWebBrowsingProvidersRoute,
    AuthSideLayoutSuperAdminWebBrowsingIndexRoute:
      AuthSideLayoutSuperAdminWebBrowsingIndexRoute,
  }

const AuthSideLayoutSuperAdminWebBrowsingRouteWithChildren =
  AuthSideLayoutSuperAdminWebBrowsingRoute._addFileChildren(
    AuthSideLayoutSuperAdminWebBrowsingRouteChildren,
  )

interface AuthSideLayoutSuperAdminRouteChildren {
  AuthSideLayoutSuperAdminCrmRoute: typeof AuthSideLayoutSuperAdminCrmRoute
  AuthSideLayoutSuperAdminEnrichmentRoute: typeof AuthSideLayoutSuperAdminEnrichmentRouteWithChildren
  AuthSideLayoutSuperAdminFeaturesRoute: typeof AuthSideLayoutSuperAdminFeaturesRoute
  AuthSideLayoutSuperAdminPrivacyRequestsRoute: typeof AuthSideLayoutSuperAdminPrivacyRequestsRoute
  AuthSideLayoutSuperAdminPromosRoute: typeof AuthSideLayoutSuperAdminPromosRoute
  AuthSideLayoutSuperAdminSubscriptionsRoute: typeof AuthSideLayoutSuperAdminSubscriptionsRoute
  AuthSideLayoutSuperAdminUsersRoute: typeof AuthSideLayoutSuperAdminUsersRoute
  AuthSideLayoutSuperAdminVisitorIdRoute: typeof AuthSideLayoutSuperAdminVisitorIdRouteWithChildren
  AuthSideLayoutSuperAdminWebBrowsingRoute: typeof AuthSideLayoutSuperAdminWebBrowsingRouteWithChildren
  AuthSideLayoutSuperAdminIndexRoute: typeof AuthSideLayoutSuperAdminIndexRoute
  AuthSideLayoutSuperAdminDataAgentsRoute: typeof AuthSideLayoutSuperAdminDataAgentsRoute
  AuthSideLayoutSuperAdminDataChangesRoute: typeof AuthSideLayoutSuperAdminDataChangesRoute
  AuthSideLayoutSuperAdminDataCompaniesRoute: typeof AuthSideLayoutSuperAdminDataCompaniesRoute
  AuthSideLayoutSuperAdminDataLookupsRoute: typeof AuthSideLayoutSuperAdminDataLookupsRoute
  AuthSideLayoutSuperAdminDataPersonasRoute: typeof AuthSideLayoutSuperAdminDataPersonasRoute
}

const AuthSideLayoutSuperAdminRouteChildren: AuthSideLayoutSuperAdminRouteChildren =
  {
    AuthSideLayoutSuperAdminCrmRoute: AuthSideLayoutSuperAdminCrmRoute,
    AuthSideLayoutSuperAdminEnrichmentRoute:
      AuthSideLayoutSuperAdminEnrichmentRouteWithChildren,
    AuthSideLayoutSuperAdminFeaturesRoute:
      AuthSideLayoutSuperAdminFeaturesRoute,
    AuthSideLayoutSuperAdminPrivacyRequestsRoute:
      AuthSideLayoutSuperAdminPrivacyRequestsRoute,
    AuthSideLayoutSuperAdminPromosRoute: AuthSideLayoutSuperAdminPromosRoute,
    AuthSideLayoutSuperAdminSubscriptionsRoute:
      AuthSideLayoutSuperAdminSubscriptionsRoute,
    AuthSideLayoutSuperAdminUsersRoute: AuthSideLayoutSuperAdminUsersRoute,
    AuthSideLayoutSuperAdminVisitorIdRoute:
      AuthSideLayoutSuperAdminVisitorIdRouteWithChildren,
    AuthSideLayoutSuperAdminWebBrowsingRoute:
      AuthSideLayoutSuperAdminWebBrowsingRouteWithChildren,
    AuthSideLayoutSuperAdminIndexRoute: AuthSideLayoutSuperAdminIndexRoute,
    AuthSideLayoutSuperAdminDataAgentsRoute:
      AuthSideLayoutSuperAdminDataAgentsRoute,
    AuthSideLayoutSuperAdminDataChangesRoute:
      AuthSideLayoutSuperAdminDataChangesRoute,
    AuthSideLayoutSuperAdminDataCompaniesRoute:
      AuthSideLayoutSuperAdminDataCompaniesRoute,
    AuthSideLayoutSuperAdminDataLookupsRoute:
      AuthSideLayoutSuperAdminDataLookupsRoute,
    AuthSideLayoutSuperAdminDataPersonasRoute:
      AuthSideLayoutSuperAdminDataPersonasRoute,
  }

const AuthSideLayoutSuperAdminRouteWithChildren =
  AuthSideLayoutSuperAdminRoute._addFileChildren(
    AuthSideLayoutSuperAdminRouteChildren,
  )

interface AuthSideLayoutActionsProfilesRouteChildren {
  AuthSideLayoutActionsProfilesPersonasRoute: typeof AuthSideLayoutActionsProfilesPersonasRoute
  AuthSideLayoutActionsProfilesProfilesRoute: typeof AuthSideLayoutActionsProfilesProfilesRoute
  AuthSideLayoutActionsProfilesIndexRoute: typeof AuthSideLayoutActionsProfilesIndexRoute
}

const AuthSideLayoutActionsProfilesRouteChildren: AuthSideLayoutActionsProfilesRouteChildren =
  {
    AuthSideLayoutActionsProfilesPersonasRoute:
      AuthSideLayoutActionsProfilesPersonasRoute,
    AuthSideLayoutActionsProfilesProfilesRoute:
      AuthSideLayoutActionsProfilesProfilesRoute,
    AuthSideLayoutActionsProfilesIndexRoute:
      AuthSideLayoutActionsProfilesIndexRoute,
  }

const AuthSideLayoutActionsProfilesRouteWithChildren =
  AuthSideLayoutActionsProfilesRoute._addFileChildren(
    AuthSideLayoutActionsProfilesRouteChildren,
  )

interface AuthSideLayoutActionsYourActionsRouteChildren {
  AuthSideLayoutActionsYourActionsActionsRoute: typeof AuthSideLayoutActionsYourActionsActionsRoute
  AuthSideLayoutActionsYourActionsActivityRoute: typeof AuthSideLayoutActionsYourActionsActivityRoute
  AuthSideLayoutActionsYourActionsIndexRoute: typeof AuthSideLayoutActionsYourActionsIndexRoute
}

const AuthSideLayoutActionsYourActionsRouteChildren: AuthSideLayoutActionsYourActionsRouteChildren =
  {
    AuthSideLayoutActionsYourActionsActionsRoute:
      AuthSideLayoutActionsYourActionsActionsRoute,
    AuthSideLayoutActionsYourActionsActivityRoute:
      AuthSideLayoutActionsYourActionsActivityRoute,
    AuthSideLayoutActionsYourActionsIndexRoute:
      AuthSideLayoutActionsYourActionsIndexRoute,
  }

const AuthSideLayoutActionsYourActionsRouteWithChildren =
  AuthSideLayoutActionsYourActionsRoute._addFileChildren(
    AuthSideLayoutActionsYourActionsRouteChildren,
  )

interface AuthSideLayoutIntegrationsAccessRouteChildren {
  AuthSideLayoutIntegrationsAccessApiRoute: typeof AuthSideLayoutIntegrationsAccessApiRoute
  AuthSideLayoutIntegrationsAccessMcpRoute: typeof AuthSideLayoutIntegrationsAccessMcpRoute
  AuthSideLayoutIntegrationsAccessIndexRoute: typeof AuthSideLayoutIntegrationsAccessIndexRoute
}

const AuthSideLayoutIntegrationsAccessRouteChildren: AuthSideLayoutIntegrationsAccessRouteChildren =
  {
    AuthSideLayoutIntegrationsAccessApiRoute:
      AuthSideLayoutIntegrationsAccessApiRoute,
    AuthSideLayoutIntegrationsAccessMcpRoute:
      AuthSideLayoutIntegrationsAccessMcpRoute,
    AuthSideLayoutIntegrationsAccessIndexRoute:
      AuthSideLayoutIntegrationsAccessIndexRoute,
  }

const AuthSideLayoutIntegrationsAccessRouteWithChildren =
  AuthSideLayoutIntegrationsAccessRoute._addFileChildren(
    AuthSideLayoutIntegrationsAccessRouteChildren,
  )

interface AuthSideLayoutSettingsOrganizationRouteChildren {
  AuthSideLayoutSettingsOrganizationCurrencyRoute: typeof AuthSideLayoutSettingsOrganizationCurrencyRoute
  AuthSideLayoutSettingsOrganizationDetailsRoute: typeof AuthSideLayoutSettingsOrganizationDetailsRoute
  AuthSideLayoutSettingsOrganizationIndexRoute: typeof AuthSideLayoutSettingsOrganizationIndexRoute
}

const AuthSideLayoutSettingsOrganizationRouteChildren: AuthSideLayoutSettingsOrganizationRouteChildren =
  {
    AuthSideLayoutSettingsOrganizationCurrencyRoute:
      AuthSideLayoutSettingsOrganizationCurrencyRoute,
    AuthSideLayoutSettingsOrganizationDetailsRoute:
      AuthSideLayoutSettingsOrganizationDetailsRoute,
    AuthSideLayoutSettingsOrganizationIndexRoute:
      AuthSideLayoutSettingsOrganizationIndexRoute,
  }

const AuthSideLayoutSettingsOrganizationRouteWithChildren =
  AuthSideLayoutSettingsOrganizationRoute._addFileChildren(
    AuthSideLayoutSettingsOrganizationRouteChildren,
  )

interface AuthSideLayoutSettingsPrivacyRouteChildren {
  AuthSideLayoutSettingsPrivacyConsentSourcesRoute: typeof AuthSideLayoutSettingsPrivacyConsentSourcesRoute
  AuthSideLayoutSettingsPrivacyRequestsRoute: typeof AuthSideLayoutSettingsPrivacyRequestsRoute
  AuthSideLayoutSettingsPrivacyServerEventsRoute: typeof AuthSideLayoutSettingsPrivacyServerEventsRoute
  AuthSideLayoutSettingsPrivacyUserConsentRoute: typeof AuthSideLayoutSettingsPrivacyUserConsentRoute
  AuthSideLayoutSettingsPrivacyIndexRoute: typeof AuthSideLayoutSettingsPrivacyIndexRoute
}

const AuthSideLayoutSettingsPrivacyRouteChildren: AuthSideLayoutSettingsPrivacyRouteChildren =
  {
    AuthSideLayoutSettingsPrivacyConsentSourcesRoute:
      AuthSideLayoutSettingsPrivacyConsentSourcesRoute,
    AuthSideLayoutSettingsPrivacyRequestsRoute:
      AuthSideLayoutSettingsPrivacyRequestsRoute,
    AuthSideLayoutSettingsPrivacyServerEventsRoute:
      AuthSideLayoutSettingsPrivacyServerEventsRoute,
    AuthSideLayoutSettingsPrivacyUserConsentRoute:
      AuthSideLayoutSettingsPrivacyUserConsentRoute,
    AuthSideLayoutSettingsPrivacyIndexRoute:
      AuthSideLayoutSettingsPrivacyIndexRoute,
  }

const AuthSideLayoutSettingsPrivacyRouteWithChildren =
  AuthSideLayoutSettingsPrivacyRoute._addFileChildren(
    AuthSideLayoutSettingsPrivacyRouteChildren,
  )

interface AuthSideLayoutRouteChildren {
  AuthSideLayoutCompaniesRoute: typeof AuthSideLayoutCompaniesRoute
  AuthSideLayoutDashboardShareRoute: typeof AuthSideLayoutDashboardShareRoute
  AuthSideLayoutEventsRoute: typeof AuthSideLayoutEventsRoute
  AuthSideLayoutFunnelsRoute: typeof AuthSideLayoutFunnelsRoute
  AuthSideLayoutGettingStartedRoute: typeof AuthSideLayoutGettingStartedRoute
  AuthSideLayoutGroupsRoute: typeof AuthSideLayoutGroupsRoute
  AuthSideLayoutHomeRoute: typeof AuthSideLayoutHomeRoute
  AuthSideLayoutJourneysRoute: typeof AuthSideLayoutJourneysRoute
  AuthSideLayoutPlaygroundRoute: typeof AuthSideLayoutPlaygroundRoute
  AuthSideLayoutProjectSettingsRoute: typeof AuthSideLayoutProjectSettingsRouteWithChildren
  AuthSideLayoutProjectsRoute: typeof AuthSideLayoutProjectsRoute
  AuthSideLayoutQueriesRoute: typeof AuthSideLayoutQueriesRoute
  AuthSideLayoutReportsRoute: typeof AuthSideLayoutReportsRoute
  AuthSideLayoutRevenueRoute: typeof AuthSideLayoutRevenueRoute
  AuthSideLayoutSearchConsoleRoute: typeof AuthSideLayoutSearchConsoleRoute
  AuthSideLayoutSettingsRoute: typeof AuthSideLayoutSettingsRoute
  AuthSideLayoutSuperAdminRoute: typeof AuthSideLayoutSuperAdminRouteWithChildren
  AuthSideLayoutTriggersRoute: typeof AuthSideLayoutTriggersRoute
  AuthSideLayoutUpgradeRoute: typeof AuthSideLayoutUpgradeRoute
  AuthSideLayoutUsersRoute: typeof AuthSideLayoutUsersRoute
  AuthSideLayoutIndexRoute: typeof AuthSideLayoutIndexRoute
  AuthSideLayoutActionsCatalogRoute: typeof AuthSideLayoutActionsCatalogRoute
  AuthSideLayoutActionsProfilesRoute: typeof AuthSideLayoutActionsProfilesRouteWithChildren
  AuthSideLayoutActionsSignalsRoute: typeof AuthSideLayoutActionsSignalsRoute
  AuthSideLayoutActionsYourActionsRoute: typeof AuthSideLayoutActionsYourActionsRouteWithChildren
  AuthSideLayoutAutomationsApiKeysRoute: typeof AuthSideLayoutAutomationsApiKeysRoute
  AuthSideLayoutAutomationsEnrichmentRoute: typeof AuthSideLayoutAutomationsEnrichmentRoute
  AuthSideLayoutAutomationsRobotsRoute: typeof AuthSideLayoutAutomationsRobotsRoute
  AuthSideLayoutCompaniesCompanyIdRoute: typeof AuthSideLayoutCompaniesCompanyIdRoute
  AuthSideLayoutFunnelsAddFunnelReportRoute: typeof AuthSideLayoutFunnelsAddFunnelReportRoute
  AuthSideLayoutIntegrationsIntegrationIdRoute: typeof AuthSideLayoutIntegrationsIntegrationIdRoute
  AuthSideLayoutIntegrationsAccessRoute: typeof AuthSideLayoutIntegrationsAccessRouteWithChildren
  AuthSideLayoutIntegrationsConnectedRoute: typeof AuthSideLayoutIntegrationsConnectedRoute
  AuthSideLayoutJourneysAddJourneyReportRoute: typeof AuthSideLayoutJourneysAddJourneyReportRoute
  AuthSideLayoutPaymentsCancelRoute: typeof AuthSideLayoutPaymentsCancelRoute
  AuthSideLayoutPaymentsSuccessRoute: typeof AuthSideLayoutPaymentsSuccessRoute
  AuthSideLayoutProjectsDetailsRoute: typeof AuthSideLayoutProjectsDetailsRoute
  AuthSideLayoutReportsAddFunnelReportRoute: typeof AuthSideLayoutReportsAddFunnelReportRoute
  AuthSideLayoutSettingsAccountRoute: typeof AuthSideLayoutSettingsAccountRoute
  AuthSideLayoutSettingsAiRoute: typeof AuthSideLayoutSettingsAiRoute
  AuthSideLayoutSettingsBillingRoute: typeof AuthSideLayoutSettingsBillingRoute
  AuthSideLayoutSettingsGroupsRoute: typeof AuthSideLayoutSettingsGroupsRoute
  AuthSideLayoutSettingsIdentitiesRoute: typeof AuthSideLayoutSettingsIdentitiesRoute
  AuthSideLayoutSettingsIntegrationsRoute: typeof AuthSideLayoutSettingsIntegrationsRoute
  AuthSideLayoutSettingsMembersRoute: typeof AuthSideLayoutSettingsMembersRoute
  AuthSideLayoutSettingsOrganizationRoute: typeof AuthSideLayoutSettingsOrganizationRouteWithChildren
  AuthSideLayoutSettingsPrivacyRoute: typeof AuthSideLayoutSettingsPrivacyRouteWithChildren
  AuthSideLayoutSettingsProjectsRoute: typeof AuthSideLayoutSettingsProjectsRoute
  AuthSideLayoutUsersUserIdRoute: typeof AuthSideLayoutUsersUserIdRoute
  AuthSideLayoutActionsIndexRoute: typeof AuthSideLayoutActionsIndexRoute
  AuthSideLayoutIntegrationsIndexRoute: typeof AuthSideLayoutIntegrationsIndexRoute
  AuthSideLayoutActionsProfilesProfileIdRoute: typeof AuthSideLayoutActionsProfilesProfileIdRoute
  AuthSideLayoutIntegrationsAttioCallbackRoute: typeof AuthSideLayoutIntegrationsAttioCallbackRoute
  AuthSideLayoutIntegrationsHubspotCallbackRoute: typeof AuthSideLayoutIntegrationsHubspotCallbackRoute
  AuthSideLayoutIntegrationsSalesforceCallbackRoute: typeof AuthSideLayoutIntegrationsSalesforceCallbackRoute
  AuthSideLayoutIntegrationsSlackCallbackRoute: typeof AuthSideLayoutIntegrationsSlackCallbackRoute
  AuthSideLayoutSettingsIdentitiesIdentityIdRoute: typeof AuthSideLayoutSettingsIdentitiesIdentityIdRoute
  AuthSideLayoutActionsYourActionsActivityRunIdRoute: typeof AuthSideLayoutActionsYourActionsActivityRunIdRoute
}

const AuthSideLayoutRouteChildren: AuthSideLayoutRouteChildren = {
  AuthSideLayoutCompaniesRoute: AuthSideLayoutCompaniesRoute,
  AuthSideLayoutDashboardShareRoute: AuthSideLayoutDashboardShareRoute,
  AuthSideLayoutEventsRoute: AuthSideLayoutEventsRoute,
  AuthSideLayoutFunnelsRoute: AuthSideLayoutFunnelsRoute,
  AuthSideLayoutGettingStartedRoute: AuthSideLayoutGettingStartedRoute,
  AuthSideLayoutGroupsRoute: AuthSideLayoutGroupsRoute,
  AuthSideLayoutHomeRoute: AuthSideLayoutHomeRoute,
  AuthSideLayoutJourneysRoute: AuthSideLayoutJourneysRoute,
  AuthSideLayoutPlaygroundRoute: AuthSideLayoutPlaygroundRoute,
  AuthSideLayoutProjectSettingsRoute:
    AuthSideLayoutProjectSettingsRouteWithChildren,
  AuthSideLayoutProjectsRoute: AuthSideLayoutProjectsRoute,
  AuthSideLayoutQueriesRoute: AuthSideLayoutQueriesRoute,
  AuthSideLayoutReportsRoute: AuthSideLayoutReportsRoute,
  AuthSideLayoutRevenueRoute: AuthSideLayoutRevenueRoute,
  AuthSideLayoutSearchConsoleRoute: AuthSideLayoutSearchConsoleRoute,
  AuthSideLayoutSettingsRoute: AuthSideLayoutSettingsRoute,
  AuthSideLayoutSuperAdminRoute: AuthSideLayoutSuperAdminRouteWithChildren,
  AuthSideLayoutTriggersRoute: AuthSideLayoutTriggersRoute,
  AuthSideLayoutUpgradeRoute: AuthSideLayoutUpgradeRoute,
  AuthSideLayoutUsersRoute: AuthSideLayoutUsersRoute,
  AuthSideLayoutIndexRoute: AuthSideLayoutIndexRoute,
  AuthSideLayoutActionsCatalogRoute: AuthSideLayoutActionsCatalogRoute,
  AuthSideLayoutActionsProfilesRoute:
    AuthSideLayoutActionsProfilesRouteWithChildren,
  AuthSideLayoutActionsSignalsRoute: AuthSideLayoutActionsSignalsRoute,
  AuthSideLayoutActionsYourActionsRoute:
    AuthSideLayoutActionsYourActionsRouteWithChildren,
  AuthSideLayoutAutomationsApiKeysRoute: AuthSideLayoutAutomationsApiKeysRoute,
  AuthSideLayoutAutomationsEnrichmentRoute:
    AuthSideLayoutAutomationsEnrichmentRoute,
  AuthSideLayoutAutomationsRobotsRoute: AuthSideLayoutAutomationsRobotsRoute,
  AuthSideLayoutCompaniesCompanyIdRoute: AuthSideLayoutCompaniesCompanyIdRoute,
  AuthSideLayoutFunnelsAddFunnelReportRoute:
    AuthSideLayoutFunnelsAddFunnelReportRoute,
  AuthSideLayoutIntegrationsIntegrationIdRoute:
    AuthSideLayoutIntegrationsIntegrationIdRoute,
  AuthSideLayoutIntegrationsAccessRoute:
    AuthSideLayoutIntegrationsAccessRouteWithChildren,
  AuthSideLayoutIntegrationsConnectedRoute:
    AuthSideLayoutIntegrationsConnectedRoute,
  AuthSideLayoutJourneysAddJourneyReportRoute:
    AuthSideLayoutJourneysAddJourneyReportRoute,
  AuthSideLayoutPaymentsCancelRoute: AuthSideLayoutPaymentsCancelRoute,
  AuthSideLayoutPaymentsSuccessRoute: AuthSideLayoutPaymentsSuccessRoute,
  AuthSideLayoutProjectsDetailsRoute: AuthSideLayoutProjectsDetailsRoute,
  AuthSideLayoutReportsAddFunnelReportRoute:
    AuthSideLayoutReportsAddFunnelReportRoute,
  AuthSideLayoutSettingsAccountRoute: AuthSideLayoutSettingsAccountRoute,
  AuthSideLayoutSettingsAiRoute: AuthSideLayoutSettingsAiRoute,
  AuthSideLayoutSettingsBillingRoute: AuthSideLayoutSettingsBillingRoute,
  AuthSideLayoutSettingsGroupsRoute: AuthSideLayoutSettingsGroupsRoute,
  AuthSideLayoutSettingsIdentitiesRoute: AuthSideLayoutSettingsIdentitiesRoute,
  AuthSideLayoutSettingsIntegrationsRoute:
    AuthSideLayoutSettingsIntegrationsRoute,
  AuthSideLayoutSettingsMembersRoute: AuthSideLayoutSettingsMembersRoute,
  AuthSideLayoutSettingsOrganizationRoute:
    AuthSideLayoutSettingsOrganizationRouteWithChildren,
  AuthSideLayoutSettingsPrivacyRoute:
    AuthSideLayoutSettingsPrivacyRouteWithChildren,
  AuthSideLayoutSettingsProjectsRoute: AuthSideLayoutSettingsProjectsRoute,
  AuthSideLayoutUsersUserIdRoute: AuthSideLayoutUsersUserIdRoute,
  AuthSideLayoutActionsIndexRoute: AuthSideLayoutActionsIndexRoute,
  AuthSideLayoutIntegrationsIndexRoute: AuthSideLayoutIntegrationsIndexRoute,
  AuthSideLayoutActionsProfilesProfileIdRoute:
    AuthSideLayoutActionsProfilesProfileIdRoute,
  AuthSideLayoutIntegrationsAttioCallbackRoute:
    AuthSideLayoutIntegrationsAttioCallbackRoute,
  AuthSideLayoutIntegrationsHubspotCallbackRoute:
    AuthSideLayoutIntegrationsHubspotCallbackRoute,
  AuthSideLayoutIntegrationsSalesforceCallbackRoute:
    AuthSideLayoutIntegrationsSalesforceCallbackRoute,
  AuthSideLayoutIntegrationsSlackCallbackRoute:
    AuthSideLayoutIntegrationsSlackCallbackRoute,
  AuthSideLayoutSettingsIdentitiesIdentityIdRoute:
    AuthSideLayoutSettingsIdentitiesIdentityIdRoute,
  AuthSideLayoutActionsYourActionsActivityRunIdRoute:
    AuthSideLayoutActionsYourActionsActivityRunIdRoute,
}

const AuthSideLayoutRouteWithChildren = AuthSideLayoutRoute._addFileChildren(
  AuthSideLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthBasicLayoutRoute: typeof AuthBasicLayoutRouteWithChildren
  AuthSideLayoutRoute: typeof AuthSideLayoutRouteWithChildren
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute
  AuthClaimRoute: typeof AuthClaimRoute
  AuthOnboardingRoute: typeof AuthOnboardingRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthBasicLayoutRoute: AuthBasicLayoutRouteWithChildren,
  AuthSideLayoutRoute: AuthSideLayoutRouteWithChildren,
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthClaimRoute: AuthClaimRoute,
  AuthOnboardingRoute: AuthOnboardingRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ConsentRoute: ConsentRoute,
  DealRoute: DealRoute,
  DemoRoute: DemoRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  SharesDashboardIdRoute: SharesDashboardIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
